import axios, { AxiosError } from "axios"
import { AnyAction } from "redux"
import { v4 as uuidv4 } from "uuid"

import { Dispatch, RNBThunkAction } from "../store.config"
import { Analytic } from "../../utils/analytics"
import {
  billOfExchangeDatumTypes,
  changeBuyOrSell,
  changeDocumentType,
  createWritingLine,
  DeactivatedDocumentInWritingForInputMask,
  decreaseCents,
  DocumentType,
  FullDocumentForInputMask,
  generateEmptyTaxIncluded,
  increaseCents,
  isFullDocumentDeactivated,
  isMagicCheckBoxDatumType,
  LineToAdd,
  MagicCheckBoxDatumTypes,
  UnitValues,
  updateAmount,
  updateGoodsOrServiceAndSourceLines,
  updateTaxIncluded,
  updateVat,
  VatAccountsWithRate,
  VatRateValue,
  WritingLine,
  WritingLinePayload,
} from "../../utils/inputMask"
import {
  DocumentSource,
  FullDocumentsActionsEnum,
  GoodsOrServices,
  fullDocumentUpdateSuccess,
} from "./fullDocuments.ducks"
import { Company, DeactivatedSettingsKey } from "./companies.ducks"
import { copyObject } from "../../utils/object"
import {
  FullDocumentModification,
  getFullDocumentModification,
  getWritingLineChanges,
  WritingLineChange,
  WritingLineModification,
} from "../../utils/inputMaskHistory"
import {
  BanLockedAccountFailure,
  DeactivatedAccountFailure,
  EditMerchantNameFailure,
  InstructionType,
  LockBannedAccountFailure,
  MerchantInstructionPayload,
} from "./merchants.ducks"
import { buyOrSell } from "../../utils/company"
import { RootState } from "../rootReducer"
import {
  GetAllMerchantsOfCompanyForCodes,
  GetCompanyMerchantCodesDataThunk,
  ToastErrorProps,
} from "./merchantCodes.ducks"
import { Account } from "./accounts.ducks"
import { LegalEntity } from "./merchantModification.ducks"
import { FileType } from "../../routes/office/company/EDM/OtherFiles"
import { getAnalyticsSuccessAction } from "./analytics.ducks"
import { cancelBatchLoading } from "./batchDocuments.ducks"
import * as R from "ramda"
import {
  showDefaultErrorToaster,
  showDefaultSuccessToaster,
} from "../notifications.config"

export const MININMUM_FD_DATE = "2010-05-01"

export const enum InputMaskActionsEnum {
  GET_INPUT_MASK_WRITING_ATTEMPT = "INPUT_MASK/getInputMaskWritingAttempt",
  GET_INPUT_MASK_WRITING_SUCCESS = "INPUT_MASK/getInputMaskWritingSuccess",
  GET_INPUT_MASK_WRITING_ERROR = "INPUT_MASK/getInputMaskWritingErrror",

  GET_INPUT_MASK_FULL_DOCUMENTS_ATTEMPT = "INPUT_MASK/getInputMaskFullDocumentsAttempt",
  GET_INPUT_MASK_FULL_DOCUMENTS_SUCCESS = "INPUT_MASK/getInputMaskFullDocumentsSuccess",
  GET_INPUT_MASK_FULL_DOCUMENTS_ERROR = "INPUT_MASK/getInputMaskFullDocumentsErrror",

  GET_INPUT_MASK_MERCHANT_ATTEMPT = "INPUT_MASK/getInputMaskMerchantAttempt",
  GET_INPUT_MASK_MERCHANT_SUCCESS = "INPUT_MASK/getInputMaskMerchantSuccess",
  GET_INPUT_MASK_MERCHANT_ERROR = "INPUT_MASK/getInputMaskMerchantErrror",

  GET_INPUT_MASK_WRITING_ARCHIVE_ATTEMPT = "INPUT_MASK/getInputMaskWritingArchiveAttempt",
  GET_INPUT_MASK_WRITING_ARCHIVE_SUCCESS = "INPUT_MASK/getInputMaskWritingArchiveSuccess",
  GET_INPUT_MASK_WRITING_ARCHIVE_ERROR = "INPUT_MASK/getInputMaskWritingArchiveErrror",

  SET_NEXT_SELECTED_FULL_DOCUMENT_ID = "INPUT_MASK/set_next_selected_full_document_id",

  GET_INPUT_MASK_DEACTIVATED_ATTEMPT = "INPUT_MASK/getInputMaskDeactivatedAttempt",
  GET_INPUT_MASK_DEACTIVATED_SUCCESS = "INPUT_MASK/getInputMaskDeactivatedSuccess",
  GET_INPUT_MASK_DEACTIVATED_ERROR = "INPUT_MASK/getInputMaskDeactivatedErrror",

  UPDATE_WRITING_LINES_ATTEMPT = "INPUT_MASK/updateWritingLinesAttempt",
  UPDATE_WRITING_LINES_SUCCESS = "INPUT_MASK/updateWritingLinesSuccess",
  UPDATE_WRITING_LINES_ERROR = "INPUT_MASK/updateWritingLinesErrror",

  GET_INPUT_MASK_ACCOUNTS_ATTEMPT = "INPUT_MASK/getInputMaskAccountsAttempt",
  GET_INPUT_MASK_ACCOUNTS_SUCCESS = "INPUT_MASK/getInputMaskAccountsSuccess",
  GET_INPUT_MASK_ACCOUNTS_ERROR = "INPUT_MASK/getInputMaskAccountsErrror",

  SELECT_NEW_ACCOUNT = "INPUT_MASK/selectNewAccount",

  GET_HISTORY_ATTEMPT = "INPUT_MASK/getHistoryAttempt",
  GET_HISTORY_SUCCESS = "INPUT_MASK/getHistorySuccess",
  GET_HISTORY_ERROR = "INPUT_MASK/getHistoryErrror",

  GET_MERCHANT_IMPACTED_DOCUMENTS_ATTEMPT = "INPUT_MASK/getMerchantImpactedDocumentsAttempt",
  GET_MERCHANT_IMPACTED_DOCUMENTS_SUCCESS = "INPUT_MASK/getMerchantImpactedDocumentsSuccess",
  GET_MERCHANT_IMPACTED_DOCUMENTS_ERROR = "INPUT_MASK/getMerchantImpactedDocumentsErrror",

  GET_IDENTIFICATION_NUMBERS_ATTEMPT = "INPUT_MASK/getIdentificationNumbersAttempt",
  GET_IDENTIFICATION_NUMBERS_SUCCESS = "INPUT_MASK/getIdentificationNumbersSuccess",
  GET_IDENTIFICATION_NUMBERS_ERROR = "INPUT_MASK/getIdentificationNumbersErrror",

  CREATE_MERCHANT_CODE_ATTEMPT = "INPUT_MASK/createMerchantCodeAttempt",
  CREATE_MERCHANT_CODE_SUCCESS = "INPUT_MASK/createMerchantCodeSuccess",
  CREATE_MERCHANT_CODE_ERROR = "INPUT_MASK/createMerchantCodeErrror",
  CREATE_MERCHANT_CODE_RESET = "INPUT_MASK/createMerchantCodeReset",

  TOGGLE_BLOCKED_BY_ALREADY_TAKEN_MERCHANT_CODE = "INPUT_MASK/toggleBlockedByAlreadyTakenMerchantCode",

  UPDATE_FULL_DOCUMENT_REVIEW = "INPUT_MASK/update_full_document_review",
  RESET_REVIEW = "INPUT_MASK/reset_review",
  UPDATE_AMOUNT = "INPUT_MASK/update_amount",
  TOGGLE_IS_FUEL_VAT = "INPUT_MASK/toggle_is_fuel_vat",
  SET_VAT_RECOVERY_ON_LINE = "INPUT_MASK/set_vat_recovery_on_line",
  UNIT_VALUES = "INPUT_MASK/unit_values",
  CREATE_LINE = "INPUT_MASK/create_line",
  DESTROY_LINE = "INPUT_MASK/destroy_line",
  INCREASE_CENTS = "INPUT_MASK/increase_cents",
  DECREASE_CENTS = "INPUT_MASK/decrease_cents",
  CHANGE_VAT = "INPUT_MASK/changeVat",
  CHANGE_BILL_OF_EXCHANGE_MERCHANT = "INPUT_MASK/changeBillOfExchangeMerchant",
  CHANGE_WRITING_LINE_ANALYTICS = "INPUT_MASK/changeWritingLineAnalytics",
  RESET_NEW_ANALYTIC_VALUES = "INPUT_MASK/resetNewAnalyticValues",
  CHANGE_ACCOUNT = "INPUT_MASK/change_account",
  CHANGE_LEGAL_ENTITY = "INPUT_MASK/change_legal_entity",
  CHANGE_MERCHANT = "INPUT_MASK/change_merchant",
  CHANGE_MERCHANT_CODE = "INPUT_MASK/change_merchant_code",
  CHANGE_TYPOLOGY = "INPUT_MASK/change_typology",
  CHANGE_GOODS_OR_SERVICES = "INPUT_MASK/change_goods_or_services",
  CHANGE_DOCUMENT_SOURCE = "INPUT_MASK/change_document_source",
  FOCUS_LINE = "INPUT_MASK/focus_line",
  SELECT_TAB = "INPUT_MASK/select_tab",
  FREE_TEXT_FULL_DOC = "INPUT_MASK/free_text_full_doc",
  PAYMENT_METHOD_FULL_DOC = "INPUT_MASK/payment_method_full_doc",
  SET_SELECTED_FULL_DOCUMENT = "INPUT_MASK/set_selected_full_document",
  STORE_CONTEXT = "INPUT_MASK/store_context",
  EXPAND_ALL_INVOICES = "INPUT_MASK/expand_all_invoices",
  MINIMIZE_ALL_INVOICES = "INPUT_MASK/minimize_all_invoices",

  SET_MERCHANT_INSTRUCTION = "INPUT_MASK/set_merchant_instruction",
  MERCHANT_INSTRUCTION_SUCCESS = "INPUT_MASK/merchant_instruction_success",
  MERCHANT_INSTRUCTION_ERROR = "INPUT_MASK/merchant_instruction_error",

  DEACTIVATE_FULL_DOCUMENT_ATTEMPT = "INPUT_MASK/deactivateFullDocumentAttempt",
  DEACTIVATE_FULL_DOCUMENT_SUCCESS = "INPUT_MASK/deactivateFullDocumentSuccess",
  DEACTIVATE_FULL_DOCUMENT_RESET = "INPUT_MASK/deactivateFullDocumentReset",
  DEACTIVATE_FULL_DOCUMENT_ERROR = "INPUT_MASK/deactivateFullDocumentErrror",

  REACTIVATE_DOCUMENT = "INPUT_MASK/reactivate_document",
  CANCEL_DOCUMENT_REACTIVATION = "INPUT_MASK/cancel_document_reactivation",

  RESET_ACCOUNT_TO_SELECT = "INPUT_MASK/reset_account_to_select",

  UPDATE_URL_FOR_FULL_DOCUMENT = "INPUT_MASK/update_url_for_full_document",
  FETCH_URL_FOR_FULL_DOCUMENT = "INPUT_MASK/fetch_url_for_full_document",
  ERROR_URL_FOR_FULL_DOCUMENT = "INPUT_MASK/error_url_for_full_document",
  FETCH_URL_FOR_DOCUMENT_IF_NEEDED = "INPUT_MASK/fetch_url_for_document_if_needed",
  SET_DOCUMENT_URL_CACHE = "INPUT_MASK/set_document_url_cache",
  SET_MERCHANT_CODE_TO_CREATE = "INPUT_MASK/set_merchant_code_to_create",

  SET_DISPLAY_INPUT_MASK_MODAL = "INPUT_MASK/set_display_input_mask_modal",
  CAN_CLOSE_INPUT_MASK_MODAL = "INPUT_MASK/can_close_input_mask_modal",

  SET_IS_DATE_PICKER_OPEN = "INPUT_MASK/set_is_date_picker_open",
  SET_SAVED_DATE_PICKER_VALUE = "INPUT_MASK/set_saved_date_picker_value",
  RESET_SAVED_DATE_PICKER_VALUE = "INPUT_MASK/reset_saved_date_picker_value",

  SAVE_SELECTED_DOCUMENT_FOR_REBIND = "INPUT_MASK/save_selected_document_for_rebind",
  RESET_NEXT_SELECTED_FULL_DOCUMENT_ID = "INPUT_MASK/reset_next_selected_full_document_id",

  UPDATE_FULL_DOCUMENT_FILE_NAME = "INPUT_MASK/update_full_document_file_name",
}

export const getInputMaskWritingAttemptAction = () =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ATTEMPT } as const)
export const getInputMaskWritingSuccessAction = (payload: InputMaskResponse) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_SUCCESS,
    payload,
  } as const)
export const getInputMaskWritingErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ERROR } as const)

export const getInputMaskFullDocumentsAttemptAction = () =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_FULL_DOCUMENTS_ATTEMPT,
  } as const)
export const getInputMaskFullDocumentsSuccessAction = (
  payload: InputMaskResponse
) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_FULL_DOCUMENTS_SUCCESS,
    payload,
  } as const)
export const getInputMaskFullDocumentsErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_FULL_DOCUMENTS_ERROR } as const)

export const getInputMaskAccountsAttemptAction = () =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_ATTEMPT } as const)
export const getInputMaskAccountsSuccessAction = (
  payload: InputMaskAccountsPayload
) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_SUCCESS,
    payload,
  } as const)

export const selectNewAccountAction = (payload: {
  buyOrsell: buyOrSell
  newAccount: Account
  writingLineUuid: string | undefined
}) =>
  ({
    type: InputMaskActionsEnum.SELECT_NEW_ACCOUNT,
    payload,
  } as const)

export const setSelectedFullDocument = (
  selectedFullDocument:
    | FullDocumentForInputMask
    | DeactivatedDocumentInWritingForInputMask
    | null
) =>
  ({
    type: InputMaskActionsEnum.SET_SELECTED_FULL_DOCUMENT,
    payload: selectedFullDocument,
  } as const)

export const getInputMaskAccountsErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_ERROR } as const)

export const getInputMaskMerchantAttemptAction = () =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_ATTEMPT } as const)
export const getInputMaskMerchantSuccessAction = (
  payload: InputMaskMerchantResponse
) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_SUCCESS,
    payload,
  } as const)
export const getInputMaskMerchantErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_ERROR } as const)

export const getInputMaskWritingArchiveAttemptAction = () =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_ATTEMPT,
  } as const)
export const getInputMaskWritingArchiveSuccessAction = (
  payload: InputMaskMerchantResponse
) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_SUCCESS,
    payload,
  } as const)
export const getInputMaskWritingArchiveErrorAction = (e: AxiosError) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_ERROR,
  } as const)

export const setNextSelectedFullDocumentIdAction = (fullDocumentId: number) =>
  ({
    type: InputMaskActionsEnum.SET_NEXT_SELECTED_FULL_DOCUMENT_ID,
    payload: fullDocumentId,
  } as const)

export const getInputMaskDeactivatedAttemptAction = () =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_ATTEMPT } as const)
export const getInputMaskDeactivatedSuccessAction = (
  payload: InputMaskResponse,
  fullDocumentId: number
) =>
  ({
    type: InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_SUCCESS,
    payload: {
      data: payload,
      fullDocumentId: fullDocumentId,
    },
  } as const)
export const getInputMaskDeactivatedErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_ERROR } as const)

export const getHistoryAttemptAction = () =>
  ({ type: InputMaskActionsEnum.GET_HISTORY_ATTEMPT } as const)
export const getHistorySuccessAction = (payload: {
  history_modifications: HistoryModification[]
}) =>
  ({
    type: InputMaskActionsEnum.GET_HISTORY_SUCCESS,
    payload,
  } as const)
export const getHistoryErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.GET_HISTORY_ERROR } as const)

export const getMerchantImpactedDocumentsAttemptAction = () =>
  ({
    type: InputMaskActionsEnum.GET_MERCHANT_IMPACTED_DOCUMENTS_ATTEMPT,
  } as const)
export const getMerchantImpactedDocumentsSuccessAction = (payload: {
  impacted_documents: number
}) =>
  ({
    type: InputMaskActionsEnum.GET_MERCHANT_IMPACTED_DOCUMENTS_SUCCESS,
    payload,
  } as const)
export const getMerchantImpactedDocumentsErrorAction = (e: AxiosError) =>
  ({
    type: InputMaskActionsEnum.GET_MERCHANT_IMPACTED_DOCUMENTS_ERROR,
  } as const)

export const createMerchantCodeResetAction = () =>
  ({
    type: InputMaskActionsEnum.CREATE_MERCHANT_CODE_RESET,
  } as const)
export const createMerchantCodeAttemptAction = () =>
  ({
    type: InputMaskActionsEnum.CREATE_MERCHANT_CODE_ATTEMPT,
  } as const)
export const createMerchantCodeSuccessAction = (payload: {
  merchant_code_id: number
}) =>
  ({
    type: InputMaskActionsEnum.CREATE_MERCHANT_CODE_SUCCESS,
    payload,
  } as const)
export const createMerchantCodeErrorAction = (error: ToastErrorProps) =>
  ({
    type: InputMaskActionsEnum.CREATE_MERCHANT_CODE_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: error.titleKey,
      bodyKey: error.bodyKey,
      bodyValues: error.bodyValues,
    },
  } as const)

export const updateWritingLinesErrorAction = ({
  titleKey,
  bodyKey,
  bodyValues,
}: {
  titleKey: string
  bodyKey: string
  bodyValues?: Record<string, string>
}) =>
  ({
    type: InputMaskActionsEnum.UPDATE_WRITING_LINES_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey,
      bodyKey,
      bodyValues,
    },
  } as const)

export const updateWritingLinesAttemptAction = () =>
  ({
    type: InputMaskActionsEnum.UPDATE_WRITING_LINES_ATTEMPT,
  } as const)
export const updateWritingLinesSuccessAction = ({
  editedWritingLines,
  editedFullDocument,
  fullDocumentId,
  merchantCodeId,
  merchantCode,
}: {
  fullDocumentId: number
  merchantCodeId: number
  merchantCode: string
  editedWritingLines: WritingLinePayload[]
  editedFullDocument: FullDocumentOnly
}) =>
  ({
    type: InputMaskActionsEnum.UPDATE_WRITING_LINES_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: "input-mask.toaster.success.title",
      bodyKey: "input-mask.toaster.success.body",
    },
    payload: {
      editedWritingLines,
      editedFullDocument,
      fullDocumentId,
      merchantCodeId,
      merchantCode,
    },
  } as const)

export const updateFullDocumentReview = (payload: FullDocumentOnly) =>
  ({
    type: InputMaskActionsEnum.UPDATE_FULL_DOCUMENT_REVIEW,
    payload,
  } as const)
export const resetReview = (payload: {
  initialFullDocument: FullDocumentOnly
  initialWritinglines: WritingLinePayload[]
}) =>
  ({
    type: InputMaskActionsEnum.RESET_REVIEW,
    payload,
  } as const)

export const updateAmountAction = (payload: {
  newAmount: string
  writingLine: WritingLinePayload
  newCurrencyAmount: string
}) =>
  ({
    type: InputMaskActionsEnum.UPDATE_AMOUNT,
    payload,
  } as const)

export const toggleIsFuelVatAction = (payload: { writingLineUuid: string }) =>
  ({
    type: InputMaskActionsEnum.TOGGLE_IS_FUEL_VAT,
    payload,
  } as const)

export const setVatRecoveryOnLineAction = (payload: {
  writingLineUuid: string
  mode: "none" | "fuel" | "partial"
  partialPercent?: number | null
}) =>
  ({
    type: InputMaskActionsEnum.SET_VAT_RECOVERY_ON_LINE,
    payload,
  } as const)

export const unitValuesAction = (payload: {
  writingLineUuid: string
  unit_values: UnitValues
}) =>
  ({
    type: InputMaskActionsEnum.UNIT_VALUES,
    payload,
  } as const)

export const createLineAction = (payload: {
  selectedOption: LineToAdd
  possibleAccounts: AllAccounts
  buyThirdPartyAccount: Account | null
}) =>
  ({
    type: InputMaskActionsEnum.CREATE_LINE,
    payload,
  } as const)

export const destroyLineAction = (payload: {
  writingLineUuid: string
  isVat: boolean
}) =>
  ({
    type: InputMaskActionsEnum.DESTROY_LINE,
    payload,
  } as const)

export const increaseCentsAction = (payload: {
  writingLine: WritingLinePayload
}) =>
  ({
    type: InputMaskActionsEnum.INCREASE_CENTS,
    payload,
  } as const)

export const decreaseCentsAction = (payload: {
  writingLine: WritingLinePayload
}) =>
  ({
    type: InputMaskActionsEnum.DECREASE_CENTS,
    payload,
  } as const)

export const changeVat = (payload: {
  writingLine: WritingLinePayload
  new_vat_rate: number
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_VAT,
    payload,
  } as const)

export const changeAccount = (payload: {
  writingLine: WritingLinePayload
  newAccount: Account
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_ACCOUNT,
    payload,
  } as const)

export const changeBillOfExchangeMerchant = (payload: {
  writingLine: WritingLinePayload
  newMerchantCodeId: number
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_BILL_OF_EXCHANGE_MERCHANT,
    payload,
  } as const)

export const changeWritingLineAnalytics = (payload: {
  writingLine: WritingLinePayload
  selectedAnalyticsId: number | null
  newAnalyticsValue: string | null
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_WRITING_LINE_ANALYTICS,
    payload,
  } as const)

export const resetNewAnalyticValues = (payload: { analytics: Analytic[] }) =>
  ({
    type: InputMaskActionsEnum.RESET_NEW_ANALYTIC_VALUES,
    payload,
  } as const)

export const updateUrlForFullDocument = (payload: string) =>
  ({
    type: InputMaskActionsEnum.UPDATE_URL_FOR_FULL_DOCUMENT,
    payload,
  } as const)
export const fetchUrlForFullDocument = () =>
  ({
    type: InputMaskActionsEnum.FETCH_URL_FOR_FULL_DOCUMENT,
  } as const)
export const errorUrlForFullDocument = () =>
  ({
    type: InputMaskActionsEnum.ERROR_URL_FOR_FULL_DOCUMENT,
  } as const)

export const setDocumentUrlCache = (payload: {
  documentId: number
  entry: DocumentUrlCacheEntry
}) =>
  ({
    type: InputMaskActionsEnum.SET_DOCUMENT_URL_CACHE,
    payload,
  } as const)

export const changeLegalEntity = (payload: {
  legalEntity: LegalEntity
  modifyLegalEntityForOtherInvoices: boolean
  analyticId?: number | null
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_LEGAL_ENTITY,
    payload,
  } as const)

export const changeMerchant = (payload: {
  merchantId: number
  merchantName: string
  merchantCode: string | null
  merchantCodeId: number | null
  analyticId: number | null
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_MERCHANT,
    payload,
  } as const)

export const changeMerchantCode = (payload: {
  merchantCodeId?: number
  merchantCode: string
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_MERCHANT_CODE,
    payload,
  } as const)

export const changeTypology = (payload: {
  documentType: DocumentType
  buyOrSell: buyOrSell
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_TYPOLOGY,
    payload,
  } as const)

export const changeGoodsOrServices = (payload: GoodsOrServices) =>
  ({
    type: InputMaskActionsEnum.CHANGE_GOODS_OR_SERVICES,
    payload,
  } as const)

export const changeDocumentSource = (payload: {
  documentSource: DocumentSource
  company: Company
}) =>
  ({
    type: InputMaskActionsEnum.CHANGE_DOCUMENT_SOURCE,
    payload,
  } as const)

export const focusLine = () =>
  ({
    type: InputMaskActionsEnum.FOCUS_LINE,
  } as const)

export const expandAllInvoices = () =>
  ({
    type: InputMaskActionsEnum.EXPAND_ALL_INVOICES,
  } as const)

export const minimizeAllInvoices = () =>
  ({
    type: InputMaskActionsEnum.MINIMIZE_ALL_INVOICES,
  } as const)

export const selectTab = (selectedTab: InputMaskTabs) =>
  ({
    type: InputMaskActionsEnum.SELECT_TAB,
    payload: selectedTab,
  } as const)

export const freeTextFullDocAction = (free_text_full_doc: string) =>
  ({
    type: InputMaskActionsEnum.FREE_TEXT_FULL_DOC,
    payload: free_text_full_doc,
  } as const)

export const paymentMethodFullDocAction = (payment_method: string) =>
  ({
    type: InputMaskActionsEnum.PAYMENT_METHOD_FULL_DOC,
    payload: payment_method,
  } as const)

export const storeContext = (payload: {
  companyId: number
  merchantId: number | null
  fiscalYearId: number
  fullDocumentsIds?: number[]
  deactivatedType?: FileType
  writingArchiveId?: number | null
}) =>
  ({
    type: InputMaskActionsEnum.STORE_CONTEXT,
    payload,
  } as const)

export const setMerchantInstruction = (payload: {
  datum_type: MagicCheckBoxDatumTypes
  merchant_instruction: GiveMerchantInstructionPayload
  writing_line_uuid: string
}) =>
  ({
    type: InputMaskActionsEnum.SET_MERCHANT_INSTRUCTION,
    payload,
  } as const)

export const merchantInstructionSuccess = (payload: { buyOrSell: buyOrSell }) =>
  ({
    type: InputMaskActionsEnum.MERCHANT_INSTRUCTION_SUCCESS,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `input-mask.modify-merchant.success.title`,
      bodyKey: `input-mask.modify-merchant.success.body-${payload.buyOrSell}`,
    },
  } as const)
export const merchantInstructionError = (payload: { buyOrSell: buyOrSell }) =>
  ({
    type: InputMaskActionsEnum.MERCHANT_INSTRUCTION_ERROR,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: `input-mask.modify-merchant.error.title`,
      bodyKey: `input-mask.modify-merchant.error.body-${payload.buyOrSell}`,
    },
  } as const)

export const deactivateFullDocumentAttemptAction = () =>
  ({ type: InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_ATTEMPT } as const)
export const deactivateFullDocumentSuccessAction = ({
  fullDocumentId,
}: {
  fullDocumentId: number
}) =>
  ({
    type: InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_SUCCESS,
    fullDocumentId,
    withToast: true,
    toasterType: "success",
    message: {
      titleKey: `input-mask.deactivate-document.success.title`,
      bodyKey: `input-mask.deactivate-document.success.body`,
    },
  } as const)
export const deactivateFullDocumentResetAction = () =>
  ({ type: InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_RESET } as const)
export const deactivateFullDocumentErrorAction = (e: AxiosError) =>
  ({ type: InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_ERROR } as const)

export const reactivateDocumentAction = ({ fd_id }: { fd_id: number }) =>
  ({
    type: InputMaskActionsEnum.REACTIVATE_DOCUMENT,
    payload: { fd_id },
  } as const)

export const cancelReactivationAction = ({ fd_id }: { fd_id: number }) =>
  ({
    type: InputMaskActionsEnum.CANCEL_DOCUMENT_REACTIVATION,
    payload: { fd_id },
  } as const)

export const resetAccountToSelectAction = () =>
  ({ type: InputMaskActionsEnum.RESET_ACCOUNT_TO_SELECT } as const)

export const setMerchantCodeToCreate = (merchantCodeToCreate: string) =>
  ({
    type: InputMaskActionsEnum.SET_MERCHANT_CODE_TO_CREATE,
    payload: merchantCodeToCreate,
  } as const)

export const toggleBlockedByAlreadyTakenMerchantCode = ({
  blockedByAlreadyTakenMerchantCode,
}: {
  blockedByAlreadyTakenMerchantCode: boolean
}) =>
  ({
    type: InputMaskActionsEnum.TOGGLE_BLOCKED_BY_ALREADY_TAKEN_MERCHANT_CODE,
    payload: { blockedByAlreadyTakenMerchantCode },
  } as const)

export const setDisplayInputMaskModalAction = (
  displayInputMaskModal: boolean,
  selectedTab: InputMaskTabs = "processed"
) =>
  ({
    type: InputMaskActionsEnum.SET_DISPLAY_INPUT_MASK_MODAL,
    payload: {
      displayInputMaskModal,
      selectedTab,
    },
  } as const)
export const setCanCloseInputMaskModalAction = (
  canCloseInputMaskModal: boolean
) =>
  ({
    type: InputMaskActionsEnum.CAN_CLOSE_INPUT_MASK_MODAL,
    payload: {
      canCloseInputMaskModal,
    },
  } as const)

export const setIsDatePickerOpenAction = (isDatePickerOpen: boolean) =>
  ({
    type: InputMaskActionsEnum.SET_IS_DATE_PICKER_OPEN,
    payload: {
      isDatePickerOpen,
    },
  } as const)
export const setSavedDatePickerValueAction = (
  param: string,
  value: string | undefined | null
) =>
  ({
    type: InputMaskActionsEnum.SET_SAVED_DATE_PICKER_VALUE,
    payload: {
      param,
      value,
    },
  } as const)
export const resetSavedDatePickerValueAction = () =>
  ({
    type: InputMaskActionsEnum.RESET_SAVED_DATE_PICKER_VALUE,
  } as const)

export const saveSelectedDocumentForRebindAction = () =>
  ({ type: InputMaskActionsEnum.SAVE_SELECTED_DOCUMENT_FOR_REBIND } as const)

export const resetNextSelectedFullDocumentIdAction = () =>
  ({ type: InputMaskActionsEnum.RESET_NEXT_SELECTED_FULL_DOCUMENT_ID } as const)

export const updateFullDocumentFileNameAction = (
  fileNameList: { id: number; file_name: string }[]
) =>
  ({
    type: InputMaskActionsEnum.UPDATE_FULL_DOCUMENT_FILE_NAME,
    payload: { fileNameList },
  } as const)

type InputMaskActionsType = ReturnType<
  | typeof getInputMaskWritingAttemptAction
  | typeof getInputMaskWritingSuccessAction
  | typeof getInputMaskWritingErrorAction
  | typeof getInputMaskFullDocumentsAttemptAction
  | typeof getInputMaskFullDocumentsSuccessAction
  | typeof getInputMaskFullDocumentsErrorAction
  | typeof getInputMaskMerchantAttemptAction
  | typeof getInputMaskMerchantSuccessAction
  | typeof getInputMaskMerchantErrorAction
  | typeof getInputMaskWritingArchiveAttemptAction
  | typeof getInputMaskWritingArchiveSuccessAction
  | typeof getInputMaskWritingArchiveErrorAction
  | typeof setNextSelectedFullDocumentIdAction
  | typeof getInputMaskDeactivatedAttemptAction
  | typeof getInputMaskDeactivatedSuccessAction
  | typeof getInputMaskDeactivatedErrorAction
  | typeof getInputMaskAccountsAttemptAction
  | typeof getInputMaskAccountsSuccessAction
  | typeof getInputMaskAccountsErrorAction
  | typeof selectNewAccountAction
  | typeof getHistoryAttemptAction
  | typeof getHistorySuccessAction
  | typeof getHistoryErrorAction
  | typeof getMerchantImpactedDocumentsAttemptAction
  | typeof getMerchantImpactedDocumentsSuccessAction
  | typeof getMerchantImpactedDocumentsErrorAction
  | typeof updateWritingLinesAttemptAction
  | typeof updateWritingLinesSuccessAction
  | typeof updateWritingLinesErrorAction
  | typeof createMerchantCodeAttemptAction
  | typeof createMerchantCodeResetAction
  | typeof createMerchantCodeSuccessAction
  | typeof createMerchantCodeErrorAction
  | typeof updateFullDocumentReview
  | typeof resetReview
  | typeof updateAmountAction
  | typeof toggleIsFuelVatAction
  | typeof setVatRecoveryOnLineAction
  | typeof unitValuesAction
  | typeof createLineAction
  | typeof destroyLineAction
  | typeof fullDocumentUpdateSuccess
  | typeof increaseCentsAction
  | typeof decreaseCentsAction
  | typeof changeVat
  | typeof changeAccount
  | typeof changeBillOfExchangeMerchant
  | typeof changeLegalEntity
  | typeof changeMerchant
  | typeof changeMerchantCode
  | typeof changeTypology
  | typeof changeGoodsOrServices
  | typeof changeDocumentSource
  | typeof focusLine
  | typeof storeContext
  | typeof selectTab
  | typeof expandAllInvoices
  | typeof minimizeAllInvoices
  | typeof freeTextFullDocAction
  | typeof paymentMethodFullDocAction
  | typeof setSelectedFullDocument
  | typeof setMerchantInstruction
  | typeof merchantInstructionSuccess
  | typeof merchantInstructionError
  | typeof deactivateFullDocumentAttemptAction
  | typeof deactivateFullDocumentSuccessAction
  | typeof deactivateFullDocumentResetAction
  | typeof deactivateFullDocumentErrorAction
  | typeof reactivateDocumentAction
  | typeof cancelReactivationAction
  | typeof resetAccountToSelectAction
  | typeof setMerchantCodeToCreate
  | typeof toggleBlockedByAlreadyTakenMerchantCode
  | typeof updateUrlForFullDocument
  | typeof fetchUrlForFullDocument
  | typeof errorUrlForFullDocument
  | typeof setDocumentUrlCache
  | typeof changeWritingLineAnalytics
  | typeof resetNewAnalyticValues
  | typeof setDisplayInputMaskModalAction
  | typeof setCanCloseInputMaskModalAction
  | typeof setIsDatePickerOpenAction
  | typeof setSavedDatePickerValueAction
  | typeof resetSavedDatePickerValueAction
  | typeof saveSelectedDocumentForRebindAction
  | typeof resetNextSelectedFullDocumentIdAction
  | typeof updateFullDocumentFileNameAction
>

export type FullDocumentOnly = Omit<FullDocumentForInputMask, "writing_lines">

export type HistoryModification =
  | WritingLineModification
  | WritingLineChange
  | FullDocumentModification

interface CentsChange {
  writing_line_uuid: string
}

export interface DocumentUrlCacheEntry {
  status: "idle" | "loading" | "success" | "failure" | "generating"
  url: string | undefined
  fetchedAt: number
  expiresAt?: number
}

export interface InputMaskState {
  full_documents_to_check: FullDocumentForInputMask[]
  deactivated_full_documents: DeactivatedDocumentInWritingForInputMask[]
  initial_full_document: FullDocumentOnly | null
  edited_full_document: FullDocumentOnly | null
  initial_writing_lines: WritingLinePayload[]
  edited_writing_lines: WritingLinePayload[]
  all_company_accounts: AllCompanyAccounts | null
  vat_accounts: VatAccountsWithRate[]
  history_modifications: HistoryModification[]
  increased_cents: CentsChange[]
  decreased_cents: CentsChange[]
  magic_checkbox: {
    vat: {
      writing_line_uuid: string
      merchant_instruction: GiveMerchantInstructionPayload | null
    } | null
    tax_excluded: {
      writing_line_uuid: string
      merchant_instruction: GiveMerchantInstructionPayload | null
    } | null
  }
  impacted_documents: number
  loading_status: "loading" | "finished"
  deactivate_status: "idle" | "success"
  companyId: number | undefined
  merchantId: number | null | undefined
  fiscalYearId: number | undefined
  writingArchiveId: number | undefined | null
  new_line_to_select: string | null
  selectedTab: InputMaskTabs
  selectedFullDocument:
    | FullDocumentForInputMask
    | DeactivatedDocumentInWritingForInputMask
    | null
  createOrUpdateMerchantCodeStatus: "idle" | "loading" | "success" | "failure"
  updateWritinglinesStatus: "idle" | "loading" | "success" | "failure"
  urlForFullDocumentStatus: "idle" | "loading" | "success" | "failure"
  accountIdToSelectFromCreation: {
    accountId: number
    writinLineUuid: string | undefined
  } | null
  autoliquidation_vat_rates: AutoliquidationVat
  autoliquidated_custom_vat_rates: AutoliquidatedCustomVatRate[]
  blockedByAlreadyTakenMerchantCode: boolean
  canAddFreeTextFullDoc: boolean
  expandInvoicesList: "expanded" | "minimized"
  allowedVatRates: number[]
  currency: MainCurrencyCode
  isSyscohada: boolean
  displayInputMaskModal: boolean
  canCloseInputMaskModal: boolean
  isDatePickerOpen: boolean
  savedDatePicker: {
    param: string
    value?: string | null
  } | null
  nextSelectedFullDocumentId?: number
  fullDocumentsIds: number[]
  fullDocumentUrlsById: Record<number, DocumentUrlCacheEntry>
  full_document_has_changed: boolean
  writing_lines_have_changed: boolean
  enable_user_pushback: boolean
}
type InputMaskTabs = "processed" | "deactivated"

export const InputMaskInitialState: InputMaskState = {
  full_documents_to_check: [],
  deactivated_full_documents: [],
  initial_full_document: null,
  edited_full_document: null,
  initial_writing_lines: [],
  edited_writing_lines: [],
  all_company_accounts: null,
  vat_accounts: [],
  history_modifications: [],
  increased_cents: [],
  decreased_cents: [],
  new_line_to_select: null,
  magic_checkbox: {
    vat: null,
    tax_excluded: null,
  },
  impacted_documents: 0,
  loading_status: "loading",
  deactivate_status: "idle",
  companyId: undefined,
  merchantId: undefined,
  fiscalYearId: undefined,
  writingArchiveId: undefined,
  selectedTab: "processed",
  selectedFullDocument: null,
  createOrUpdateMerchantCodeStatus: "idle",
  updateWritinglinesStatus: "idle",
  urlForFullDocumentStatus: "idle",
  accountIdToSelectFromCreation: null,
  autoliquidation_vat_rates: {
    eu_vat: 0,
    eu_goods_vat: 0,
    world_vat: 0,
    world_goods_vat: 0,
    construction_vat: 0,
  },
  autoliquidated_custom_vat_rates: [],
  blockedByAlreadyTakenMerchantCode: false,
  canAddFreeTextFullDoc: false,
  expandInvoicesList: "minimized",
  allowedVatRates: [],
  currency: "EUR",
  isSyscohada: false,
  displayInputMaskModal: false,
  canCloseInputMaskModal: false,
  isDatePickerOpen: false,
  savedDatePicker: null,
  fullDocumentsIds: [],
  fullDocumentUrlsById: {},
  full_document_has_changed: false,
  writing_lines_have_changed: false,
  enable_user_pushback: false,
}

function withChangeFlags(state: InputMaskState): InputMaskState {
  return {
    ...state,
    full_document_has_changed: !R.equals(
      state.initial_full_document,
      state.edited_full_document
    ),
    writing_lines_have_changed: !R.equals(
      state.initial_writing_lines,
      state.edited_writing_lines
    ),
  }
}

function inputMaskReducerInternal(
  state = InputMaskInitialState,
  action: InputMaskActionsType
): InputMaskState {
  switch (action.type) {
    case InputMaskActionsEnum.GET_INPUT_MASK_FULL_DOCUMENTS_ATTEMPT:
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: state.displayInputMaskModal,
        isDatePickerOpen: false,
        nextSelectedFullDocumentId: state.nextSelectedFullDocumentId,
        selectedTab: state.selectedTab,
      }
    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ATTEMPT:
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: state.displayInputMaskModal,
        isDatePickerOpen: false,
        nextSelectedFullDocumentId: state.nextSelectedFullDocumentId,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_SUCCESS:
      const fullDocumentIndex = state.nextSelectedFullDocumentId
        ? action.payload.full_documents_to_check.findIndex(
            (fullDocument) =>
              fullDocument.fd_id === state.nextSelectedFullDocumentId
          )
        : -1

      const shouldSelectFirstWritingDocument =
        !state.nextSelectedFullDocumentId || fullDocumentIndex >= 0

      return {
        ...state,
        ...action.payload,
        canAddFreeTextFullDoc: action.payload.can_add_free_text_full_doc,
        loading_status: "finished",
        selectedFullDocument:
          fullDocumentIndex >= 0
            ? action.payload.full_documents_to_check[fullDocumentIndex]
            : shouldSelectFirstWritingDocument &&
              action.payload.full_documents_to_check.length > 0
            ? action.payload.full_documents_to_check[0]
            : null,
        currency: action.payload.currency,
        isSyscohada: action.payload.is_syscohada,
        allowedVatRates: action.payload.allowed_vat_rates,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_FULL_DOCUMENTS_SUCCESS:
      const fullDocumentsIndex = state.nextSelectedFullDocumentId
        ? action.payload.full_documents_to_check.findIndex(
            (fullDocument) =>
              fullDocument.fd_id === state.nextSelectedFullDocumentId
          )
        : -1

      const shouldSelectFirstDocument =
        !state.nextSelectedFullDocumentId || fullDocumentsIndex >= 0

      return {
        ...state,
        ...action.payload,
        canAddFreeTextFullDoc: action.payload.can_add_free_text_full_doc,
        loading_status: "finished",
        selectedFullDocument:
          fullDocumentsIndex >= 0
            ? action.payload.full_documents_to_check[fullDocumentsIndex]
            : shouldSelectFirstDocument &&
              action.payload.full_documents_to_check.length > 0
            ? action.payload.full_documents_to_check[0]
            : null,
        currency: action.payload.currency,
        isSyscohada: action.payload.is_syscohada,
        allowedVatRates: action.payload.allowed_vat_rates,
        selectedTab:
          action.payload.full_documents_to_check.length === 0 &&
          action.payload.deactivated_full_documents.length > 0
            ? "deactivated"
            : state.selectedTab,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ERROR:
      return {
        ...state,
        loading_status: "finished",
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_ATTEMPT:
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: state.displayInputMaskModal,
        isDatePickerOpen: false,
        nextSelectedFullDocumentId: state.nextSelectedFullDocumentId,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_SUCCESS:
      const merchantFullDocumentIndex = state.nextSelectedFullDocumentId
        ? action.payload.full_documents_to_check.findIndex(
            (fullDocument) =>
              fullDocument.fd_id === state.nextSelectedFullDocumentId
          )
        : -1

      const shouldSelectFirstMerchantDocument =
        !state.nextSelectedFullDocumentId || merchantFullDocumentIndex >= 0

      return {
        ...state,
        ...action.payload,
        loading_status: "finished",
        selectedFullDocument:
          merchantFullDocumentIndex >= 0
            ? action.payload.full_documents_to_check[merchantFullDocumentIndex]
            : shouldSelectFirstMerchantDocument &&
              action.payload.full_documents_to_check.length > 0
            ? action.payload.full_documents_to_check[0]
            : null,
        canAddFreeTextFullDoc: action.payload.can_add_free_text_full_doc,
        currency: action.payload.currency,
        isSyscohada: action.payload.is_syscohada,
        allowedVatRates: action.payload.allowed_vat_rates,
      }
    case InputMaskActionsEnum.GET_INPUT_MASK_MERCHANT_ERROR:
      return {
        ...state,
        loading_status: "finished",
      }

    case InputMaskActionsEnum.SET_NEXT_SELECTED_FULL_DOCUMENT_ID:
      return {
        ...state,
        nextSelectedFullDocumentId: action.payload,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_ATTEMPT:
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: state.displayInputMaskModal,
        isDatePickerOpen: false,
        nextSelectedFullDocumentId: state.nextSelectedFullDocumentId,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_SUCCESS:
      const writingArchiveFullDocumentIndex = state.nextSelectedFullDocumentId
        ? action.payload.full_documents_to_check.findIndex(
            (fullDocument) =>
              fullDocument.fd_id === state.nextSelectedFullDocumentId
          )
        : -1

      const shouldSelectFirstWritingArchiveDocument =
        !state.nextSelectedFullDocumentId ||
        writingArchiveFullDocumentIndex >= 0

      return {
        ...state,
        ...action.payload,
        loading_status: "finished",
        selectedFullDocument:
          writingArchiveFullDocumentIndex >= 0
            ? action.payload.full_documents_to_check[
                writingArchiveFullDocumentIndex
              ]
            : shouldSelectFirstWritingArchiveDocument &&
              action.payload.full_documents_to_check.length > 0
            ? action.payload.full_documents_to_check[0]
            : null,
        canAddFreeTextFullDoc: action.payload.can_add_free_text_full_doc,
        currency: action.payload.currency,
        isSyscohada: action.payload.is_syscohada,
        allowedVatRates: action.payload.allowed_vat_rates,
      }
    case InputMaskActionsEnum.GET_INPUT_MASK_WRITING_ARCHIVE_ERROR:
      return {
        ...state,
        loading_status: "finished",
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_ATTEMPT:
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: state.displayInputMaskModal,
        isDatePickerOpen: false,
        nextSelectedFullDocumentId: state.nextSelectedFullDocumentId,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_SUCCESS:
      const deactivatedfullDocumentIndex = state.nextSelectedFullDocumentId
        ? action.payload.data.deactivated_full_documents.findIndex(
            (fullDocument) =>
              fullDocument.fd_id === state.nextSelectedFullDocumentId
          )
        : 0

      const sortedDeactivatedDocuments = [
        ...action.payload.data.deactivated_full_documents,
      ].sort(
        (a, b) =>
          +(b.fd_id === action.payload.fullDocumentId) -
          +(a.fd_id === action.payload.fullDocumentId)
      )

      return {
        ...state,
        ...action.payload.data,
        deactivated_full_documents: sortedDeactivatedDocuments,
        canAddFreeTextFullDoc: action.payload.data.can_add_free_text_full_doc,
        loading_status: "finished",
        selectedTab: "deactivated",
        selectedFullDocument:
          action.payload.data.deactivated_full_documents[
            deactivatedfullDocumentIndex
          ],
        currency: action.payload.data.currency,
        isSyscohada: action.payload.data.is_syscohada,
        allowedVatRates: action.payload.data.allowed_vat_rates,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_DEACTIVATED_ERROR:
      return {
        ...state,
        loading_status: "finished",
      }

    case InputMaskActionsEnum.GET_HISTORY_SUCCESS:
      return {
        ...state,
        history_modifications: action.payload.history_modifications,
      }

    case InputMaskActionsEnum.GET_MERCHANT_IMPACTED_DOCUMENTS_SUCCESS:
      return {
        ...state,
        impacted_documents: action.payload.impacted_documents,
      }

    case InputMaskActionsEnum.GET_MERCHANT_IMPACTED_DOCUMENTS_ERROR:
      return {
        ...state,
        impacted_documents: 0,
      }

    case InputMaskActionsEnum.CREATE_MERCHANT_CODE_ATTEMPT: {
      return {
        ...state,
        createOrUpdateMerchantCodeStatus: "loading",
      }
    }

    case InputMaskActionsEnum.CREATE_MERCHANT_CODE_ERROR: {
      return {
        ...state,
        createOrUpdateMerchantCodeStatus: "failure",
      }
    }

    case InputMaskActionsEnum.CREATE_MERCHANT_CODE_RESET: {
      return {
        ...state,
        createOrUpdateMerchantCodeStatus: "idle",
      }
    }

    case InputMaskActionsEnum.CREATE_MERCHANT_CODE_SUCCESS:
      if (!state.edited_full_document) {
        return { ...state }
      }
      return {
        ...state,
        edited_full_document: {
          ...state.edited_full_document,
          merchant_code_id: action.payload.merchant_code_id,
        },
        createOrUpdateMerchantCodeStatus: "success",
      }

    case InputMaskActionsEnum.UPDATE_URL_FOR_FULL_DOCUMENT: {
      if (action.payload !== state.selectedFullDocument?.display_url) {
        const broadcastChannel = new BroadcastChannel("input_mask_invoice_url")
        broadcastChannel.postMessage(action.payload)
        broadcastChannel.close()
      }

      if (!state.selectedFullDocument) {
        const newSelectedFullDocument: FullDocumentForInputMask = {
          display_url: action.payload,
          documents: [],
          merchant_code_to_create: "",
          fd_id: 0,
          document_type: "invoice" as DocumentType,
          buy_or_sell: "buy",
          fd_status: "",
          journal_code: "",
          journal_id: null,
          periodicity_date_start: null,
          periodicity_date_end: null,
          fd_document_date: "",
          fd_document_due_date: null,
          fd_document_reference: null,
          fd_automatic_reference: null,
          legal_entity_id: 0,
          fd_user_file_name: "",
          original_file_name: "",
          merchant_code: "",
          merchant_code_id: 0,
          merchant_name: "",
          merchant_id: 0,
          writing_lines: [],
          merchant_buy_default_account_id: null,
          merchant_buy_vat_default_account_id: null,
          merchant_sell_default_account_id: null,
          merchant_sell_vat_default_account_id: null,
          goods_or_services: null,
          document_source: null,
          previously_deactivated_because: null,
          free_text_full_doc: null,
          ocr_ttc: null,
          payment_method: "",
        }
        const result: InputMaskState = {
          ...state,
          urlForFullDocumentStatus: "success" as const,
          selectedFullDocument: newSelectedFullDocument,
        }
        return result
      }

      const result: InputMaskState = {
        ...state,
        urlForFullDocumentStatus: "success" as const,
        selectedFullDocument: {
          ...state.selectedFullDocument,
          display_url: action.payload,
        },
      }
      return result
    }
    case InputMaskActionsEnum.FETCH_URL_FOR_FULL_DOCUMENT: {
      if (!state.selectedFullDocument) {
        return { ...state, urlForFullDocumentStatus: "loading" }
      }

      return {
        ...state,

        selectedFullDocument: {
          ...state.selectedFullDocument,
          display_url: "",
        },
        urlForFullDocumentStatus: "loading",
      }
    }
    case InputMaskActionsEnum.ERROR_URL_FOR_FULL_DOCUMENT: {
      if (!state.selectedFullDocument) {
        return { ...state, urlForFullDocumentStatus: "failure" }
      }

      return {
        ...state,

        selectedFullDocument: {
          ...state.selectedFullDocument,
          display_url: "",
        },
        urlForFullDocumentStatus: "failure",
      }
    }
    case InputMaskActionsEnum.SET_DOCUMENT_URL_CACHE: {
      return {
        ...state,
        fullDocumentUrlsById: {
          ...state.fullDocumentUrlsById,
          [action.payload.documentId]: action.payload.entry,
        },
      }
    }

    case InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_ATTEMPT:
      return { ...state, all_company_accounts: null }

    case InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_SUCCESS:
      return {
        ...state,
        autoliquidation_vat_rates: action.payload.autoliquidation_vat_rates,
        all_company_accounts: action.payload.all_company_accounts,
        autoliquidated_custom_vat_rates:
          action.payload.autoliquidated_custom_vat_rates,
      }

    case InputMaskActionsEnum.GET_INPUT_MASK_ACCOUNTS_ERROR:
      return { ...state, all_company_accounts: null }

    case InputMaskActionsEnum.SELECT_NEW_ACCOUNT: {
      if (!state.all_company_accounts) return { ...state }
      const buyOrSell = action.payload.buyOrsell

      if (buyOrSell === "buy") {
        return {
          ...state,
          accountIdToSelectFromCreation: {
            accountId: action.payload.newAccount.id,
            writinLineUuid: action.payload.writingLineUuid,
          },
          autoliquidation_vat_rates: { ...state.autoliquidation_vat_rates },
          all_company_accounts: {
            sell: { ...state.all_company_accounts.sell },
            buy: {
              ...state.all_company_accounts.buy,
              tax_excluded: [
                ...state.all_company_accounts.buy.tax_excluded,
                action.payload.newAccount,
              ],
            },
          },
        }
      } else {
        return {
          ...state,
          accountIdToSelectFromCreation: {
            accountId: action.payload.newAccount.id,
            writinLineUuid: action.payload.writingLineUuid,
          },
          autoliquidation_vat_rates: { ...state.autoliquidation_vat_rates },
          all_company_accounts: {
            sell: {
              ...state.all_company_accounts.sell,
              tax_excluded: [
                ...state.all_company_accounts.sell.tax_excluded,
                action.payload.newAccount,
              ],
            },
            buy: {
              ...state.all_company_accounts.buy,
            },
          },
        }
      }
    }

    case InputMaskActionsEnum.UPDATE_WRITING_LINES_ATTEMPT: {
      return {
        ...state,
        updateWritinglinesStatus: "loading",
      }
    }

    case InputMaskActionsEnum.UPDATE_WRITING_LINES_SUCCESS: {
      const fullDocuments = copyObject(state.full_documents_to_check)
      const modifiedFullDocuments = fullDocuments.map((fd) => {
        if (fd.fd_id !== action.payload.fullDocumentId) {
          return fd
        }
        if (
          fd.merchant_id !== action.payload.editedFullDocument["merchant_id"]
        ) {
          action.payload.editedFullDocument["merchant_code"] =
            action.payload.merchantCode
          action.payload.editedFullDocument["merchant_code_id"] =
            action.payload.merchantCodeId
        }

        if (state.edited_full_document?.merchant_code_to_create) {
          return {
            ...action.payload.editedFullDocument,
            merchant_code_to_create:
              state.edited_full_document?.merchant_code_to_create,
            writing_lines: action.payload.editedWritingLines,
          }
        }
        return {
          ...action.payload.editedFullDocument,
          writing_lines: action.payload.editedWritingLines,
        }
      })
      return {
        ...state,
        updateWritinglinesStatus: "success",
        initial_full_document: action.payload.editedFullDocument,
        edited_full_document: action.payload.editedFullDocument,
        initial_writing_lines: action.payload.editedWritingLines,
        edited_writing_lines: action.payload.editedWritingLines,
        full_documents_to_check: modifiedFullDocuments,
        deactivated_full_documents: state.deactivated_full_documents.filter(
          (d) => !d.is_being_reactivated
        ),
      }
    }

    case InputMaskActionsEnum.UPDATE_WRITING_LINES_ERROR: {
      return {
        ...state,
        updateWritinglinesStatus: "idle",
        edited_full_document: state.initial_full_document,
        edited_writing_lines: state.initial_writing_lines,
      }
    }

    case InputMaskActionsEnum.UPDATE_FULL_DOCUMENT_REVIEW: {
      return {
        ...state,
        edited_full_document: action.payload,
      }
    }

    case InputMaskActionsEnum.SELECT_TAB: {
      const selectedTab = action.payload

      const isCurrentDocumentBeingReactivated =
        state.deactivated_full_documents.some(
          (d) => d.fd_id === state.edited_full_document?.fd_id
        )

      if (
        state.updateWritinglinesStatus === "loading" ||
        state.createOrUpdateMerchantCodeStatus === "loading"
      ) {
        return { ...state }
      }

      if (isCurrentDocumentBeingReactivated) {
        // block navigation while reactivation
        return { ...state }
      }

      if (selectedTab === "deactivated") {
        return {
          ...state,
          selectedTab,
          selectedFullDocument: state.deactivated_full_documents[0],
          urlForFullDocumentStatus: "idle",
        }
      }
      const firstDocument =
        state.full_documents_to_check && state.full_documents_to_check[0]
          ? copyObject(state.full_documents_to_check[0])
          : null
      return {
        ...state,
        selectedTab,
        selectedFullDocument: firstDocument,
        initial_full_document: firstDocument,
        edited_full_document: firstDocument,
        initial_writing_lines: firstDocument?.writing_lines || [],
        edited_writing_lines: firstDocument?.writing_lines || [],
        urlForFullDocumentStatus: "idle",
      }
    }

    case InputMaskActionsEnum.FREE_TEXT_FULL_DOC: {
      const selected = state.selectedFullDocument

      if (isAssigned(selected)) {
        selected.free_text_full_doc = action.payload
      }

      return {
        ...state,
        selectedFullDocument: selected,
        edited_full_document: state.edited_full_document
          ? {
              ...state.edited_full_document,
              free_text_full_doc: action.payload,
            }
          : null,
      }
    }

    case InputMaskActionsEnum.PAYMENT_METHOD_FULL_DOC: {
      return {
        ...state,
        edited_full_document: state.edited_full_document
          ? {
              ...state.edited_full_document,
              payment_method: action.payload,
            }
          : null,
      }
    }

    case InputMaskActionsEnum.SET_SELECTED_FULL_DOCUMENT: {
      const isCurrentDocumentBeingReactivated =
        state.deactivated_full_documents.some(
          (d) => d.fd_id === state.edited_full_document?.fd_id
        )

      if (
        state.updateWritinglinesStatus === "loading" ||
        state.createOrUpdateMerchantCodeStatus === "loading"
      ) {
        return { ...state }
      }

      if (isCurrentDocumentBeingReactivated) {
        return { ...state }
      }
      if (!action.payload) {
        return { ...state }
      }

      const displayUrl = action.payload.display_url

      const isActionFullDocumentDeactivated = isFullDocumentDeactivated(
        action.payload
      )
      if (isActionFullDocumentDeactivated) {
        return {
          ...state,
          selectedFullDocument: {
            ...action.payload,
            display_url: displayUrl,
          },
          updateWritinglinesStatus: "idle",
          urlForFullDocumentStatus: "idle",
        }
      } else {
        const writing_lines = action.payload.writing_lines

        const without_writing_lines = {
          documents: action.payload.documents,
          display_url: displayUrl,
          fd_id: action.payload.fd_id,
          document_type: action.payload.document_type,
          document_source: action.payload.document_source,
          goods_or_services: action.payload.goods_or_services,
          fd_status: action.payload.fd_status,
          buy_or_sell: action.payload.buy_or_sell,
          journal_code: action.payload.journal_code,
          journal_id: action.payload.journal_id ?? null,
          periodicity_date_start: action.payload.periodicity_date_start,
          periodicity_date_end: action.payload.periodicity_date_end,
          fd_document_date: action.payload.fd_document_date,
          fd_document_due_date: action.payload.fd_document_due_date,
          fd_document_reference: action.payload.fd_document_reference,
          fd_automatic_reference: action.payload.fd_automatic_reference,
          fd_user_file_name: action.payload.fd_user_file_name,
          original_file_name: action.payload.original_file_name,
          legal_entity_id: action.payload.legal_entity_id,
          merchant_code: action.payload.merchant_code,
          merchant_code_id: action.payload.merchant_code_id,
          merchant_name: action.payload.merchant_name,
          merchant_id: action.payload.merchant_id,
          merchant_buy_default_account_id:
            action.payload.merchant_buy_default_account_id,
          merchant_buy_vat_default_account_id:
            action.payload.merchant_buy_vat_default_account_id,
          merchant_sell_default_account_id:
            action.payload.merchant_sell_default_account_id,
          merchant_sell_vat_default_account_id:
            action.payload.merchant_sell_vat_default_account_id,
          previously_deactivated_because: null,
          free_text_full_doc: action.payload.free_text_full_doc,
          merchant_code_to_create: "",
          ocr_ttc: action.payload.ocr_ttc,
          payment_method: action.payload.payment_method,
          full_document_file_name: action.payload.full_document_file_name,
        }

        return {
          ...state,
          initial_full_document: without_writing_lines,
          edited_full_document: without_writing_lines,
          initial_writing_lines: [...writing_lines],
          edited_writing_lines: [...writing_lines],
          increased_cents: [],
          decreased_cents: [],
          magic_checkbox: {
            vat: null,
            tax_excluded: null,
          },
          impacted_documents: 0,
          selectedFullDocument: {
            ...action.payload,
            display_url: displayUrl,
          },
          updateWritinglinesStatus: "idle",
          urlForFullDocumentStatus: "idle",
        }
      }
    }

    case InputMaskActionsEnum.RESET_REVIEW:
      const newFullDocs = state.full_documents_to_check.map((full_doc) => {
        const initialFullDocument = action.payload.initialFullDocument
        if (
          full_doc.merchant_id === state.edited_full_document?.merchant_id &&
          full_doc.legal_entity_id ===
            state.edited_full_document.legal_entity_id
        ) {
          return {
            ...full_doc,
            merchant_id: initialFullDocument.merchant_id,
            merchant_name: initialFullDocument.merchant_name,
            merchant_code_id: initialFullDocument.merchant_code_id,
            merchant_code: initialFullDocument.merchant_code,
          }
        } else {
          return full_doc
        }
      })

      return {
        ...state,
        edited_full_document: action.payload.initialFullDocument,
        edited_writing_lines: action.payload.initialWritinglines,
        increased_cents: [],
        decreased_cents: [],
        magic_checkbox: {
          vat: null,
          tax_excluded: null,
        },
        impacted_documents: 0,
        full_documents_to_check: newFullDocs,
      }

    case InputMaskActionsEnum.UPDATE_AMOUNT: {
      const existingLines = copyObject(state.edited_writing_lines)

      const modifiedLines = updateAmount({
        newAmount: action.payload.newAmount,
        newCurrencyAmount: action.payload.newCurrencyAmount,
        writingLine: action.payload.writingLine,
        existingLines,
        currency: state.currency,
      })

      const newIncreasedCents = state.increased_cents.filter(
        (i) =>
          i.writing_line_uuid !== action.payload.writingLine.writing_line_uuid
      )
      const newDecreasedCents = state.decreased_cents.filter(
        (i) =>
          i.writing_line_uuid !== action.payload.writingLine.writing_line_uuid
      )
      return {
        ...state,
        edited_writing_lines: modifiedLines,
        increased_cents: newIncreasedCents,
        decreased_cents: newDecreasedCents,
      }
    }

    case InputMaskActionsEnum.INCREASE_CENTS: {
      const existingLines = copyObject(state.edited_writing_lines)

      const modifiedLines = increaseCents({
        writingLine: action.payload.writingLine,
        existingLines,
      })

      const hasAlreadyBeenDecreased = state.decreased_cents.some(
        (d) =>
          d.writing_line_uuid === action.payload.writingLine.writing_line_uuid
      )

      if (hasAlreadyBeenDecreased) {
        // if we have decreased VAT previously, reset
        return {
          ...state,
          edited_writing_lines: modifiedLines,
          increased_cents: state.increased_cents.filter(
            (i) =>
              i.writing_line_uuid !==
              action.payload.writingLine.writing_line_uuid
          ),
          decreased_cents: state.decreased_cents.filter(
            (i) =>
              i.writing_line_uuid !==
              action.payload.writingLine.writing_line_uuid
          ),
        }
      }

      // otherwise, only disable + button
      return {
        ...state,
        edited_writing_lines: modifiedLines,
        increased_cents: [
          ...state.increased_cents,
          {
            writing_line_uuid: action.payload.writingLine.writing_line_uuid,
          },
        ],
      }
    }

    case InputMaskActionsEnum.DECREASE_CENTS: {
      const existingLines = copyObject(state.edited_writing_lines)

      const modifiedLines = decreaseCents({
        writingLine: action.payload.writingLine,
        existingLines,
      })

      const hasAlreadyBeenIncreased = state.increased_cents.some(
        (i) =>
          i.writing_line_uuid === action.payload.writingLine.writing_line_uuid
      )

      if (hasAlreadyBeenIncreased) {
        // if we have increased VAT previously, reset
        return {
          ...state,
          edited_writing_lines: modifiedLines,
          decreased_cents: state.decreased_cents.filter(
            (d) =>
              d.writing_line_uuid !==
              action.payload.writingLine.writing_line_uuid
          ),
          increased_cents: state.increased_cents.filter(
            (d) =>
              d.writing_line_uuid !==
              action.payload.writingLine.writing_line_uuid
          ),
        }
      }

      // otherwise, only disable - button
      return {
        ...state,
        edited_writing_lines: modifiedLines,
        decreased_cents: [
          ...state.decreased_cents,
          {
            writing_line_uuid: action.payload.writingLine.writing_line_uuid,
          },
        ],
      }
    }

    case InputMaskActionsEnum.CHANGE_VAT: {
      const existingLines = copyObject(state.edited_writing_lines)
      let modifiedLines = existingLines

      if (
        state.edited_full_document?.buy_or_sell &&
        state.all_company_accounts
      ) {
        modifiedLines = updateVat(
          action.payload.new_vat_rate,
          action.payload.writingLine,
          existingLines,
          state.edited_full_document?.buy_or_sell,
          state.edited_full_document?.goods_or_services,
          state.vat_accounts,
          state.all_company_accounts[state.edited_full_document.buy_or_sell]
        )
      }

      return {
        ...state,
        edited_writing_lines: modifiedLines,
      }
    }

    case InputMaskActionsEnum.CREATE_LINE: {
      if (!state.initial_full_document || !state.edited_full_document) {
        return { ...state }
      }
      const existingLines = copyObject(state.edited_writing_lines)

      const editedFullDocument = {
        ...state.edited_full_document,
      }

      const accountsConfiguration = {
        merchant_buy_default_account_id:
          state.initial_full_document.merchant_buy_default_account_id,
        merchant_buy_vat_default_account_id:
          state.initial_full_document.merchant_buy_vat_default_account_id,
        merchant_sell_default_account_id:
          state.initial_full_document.merchant_sell_default_account_id,
        merchant_sell_vat_default_account_id:
          state.initial_full_document.merchant_sell_vat_default_account_id,
        vat_accounts: state.vat_accounts,
        buy_or_sell:
          state?.edited_full_document?.buy_or_sell ||
          state.initial_full_document.buy_or_sell,
      }

      const autoliquidation_vat_rates = state.autoliquidation_vat_rates
      const currency = state.currency

      const { modifiedLines } = createWritingLine({
        existingLines,
        selectedOption: action.payload.selectedOption,
        possibleAccounts: action.payload.possibleAccounts,
        accountsConfiguration,
        documentType: state.edited_full_document.document_type,
        buyThirdPartyAccount: action.payload.buyThirdPartyAccount,
        autoliquidation_vat_rates: autoliquidation_vat_rates,
        currency,
        allowedVatRates: state.allowedVatRates,
        all_company_accounts: state.all_company_accounts,
        vat_accounts: state.vat_accounts,
        goods_or_services: state.edited_full_document.goods_or_services,
        autoliquidated_custom_vat_rates: state.autoliquidated_custom_vat_rates,
      })

      return {
        ...state,
        edited_writing_lines: modifiedLines,
        edited_full_document: editedFullDocument,
      }
    }

    case InputMaskActionsEnum.TOGGLE_IS_FUEL_VAT: {
      const existingLines = copyObject(state.edited_writing_lines)

      const modifiedLines = existingLines.map((l) => {
        if (l.writing_line_uuid !== action.payload.writingLineUuid) {
          return l
        }
        return {
          ...l,
          is_fuel_vat_line: !l.is_fuel_vat_line,
        }
      })

      return {
        ...state,
        edited_writing_lines: modifiedLines,
      }
    }

    case InputMaskActionsEnum.SET_VAT_RECOVERY_ON_LINE: {
      const existingLines = copyObject(state.edited_writing_lines)
      const { writingLineUuid, mode, partialPercent } = action.payload
      const modifiedLines = existingLines.map((l) => {
        if (l.writing_line_uuid !== writingLineUuid) {
          return l
        }
        if (mode === "none") {
          return {
            ...l,
            is_fuel_vat_line: false,
            partial_vat_recovery_percentage: null,
          }
        }
        if (mode === "fuel") {
          return {
            ...l,
            is_fuel_vat_line: true,
            partial_vat_recovery_percentage: null,
          }
        }
        return {
          ...l,
          is_fuel_vat_line: false,
          partial_vat_recovery_percentage:
            partialPercent != null &&
            partialPercent >= 1 &&
            partialPercent <= 99
              ? partialPercent
              : null,
        }
      })

      return {
        ...state,
        edited_writing_lines: modifiedLines,
      }
    }

    case InputMaskActionsEnum.UNIT_VALUES: {
      const existingLines = copyObject(state.edited_writing_lines)

      const modifiedLines = existingLines.map((l) => {
        if (
          l.writing_line_uuid === action.payload.writingLineUuid &&
          (l.datum_type === "tax_excluded" ||
            l.datum_type === "tax_excluded_bill_of_exchange" ||
            l.datum_type === "custom")
        ) {
          return {
            ...l,
            unit: { id: action.payload.unit_values.unit.id },
            unit_quantity: action.payload.unit_values.unit_quantity,
            unit_description: action.payload.unit_values.unit_description,
            unit_2: { id: action.payload.unit_values.unit_2.id },
            unit_2_quantity: action.payload.unit_values.unit_2_quantity,
            unit_2_description: action.payload.unit_values.unit_2_description,
          }
        }
        return l
      })

      return {
        ...state,
        edited_writing_lines: modifiedLines,
      }
    }

    case InputMaskActionsEnum.DESTROY_LINE: {
      const existingLines = copyObject(state.edited_writing_lines)

      const filteredLines = action.payload.isVat
        ? existingLines
            .filter(
              (l) =>
                l.writing_line_uuid !== action.payload.writingLineUuid ||
                !l.datum_type.includes("vat")
            )
            .map((l) => {
              if (l.writing_line_uuid === action.payload.writingLineUuid) {
                return {
                  ...l,
                  vat_rate: "0",
                }
              }
              return l
            })
        : existingLines.filter(
            (l) => l.writing_line_uuid !== action.payload.writingLineUuid
          )

      const linesWithUpdatedTaxIncluded = updateTaxIncluded(filteredLines)

      return {
        ...state,
        edited_writing_lines: linesWithUpdatedTaxIncluded,
      }
    }
    case FullDocumentsActionsEnum.FULL_DOCUMENT_UPDATE_SUCCESS: {
      const updatedFullDocument: DeactivatedDocumentInWritingForInputMask[] =
        copyObject(state.deactivated_full_documents)

      updatedFullDocument.forEach((fd) => {
        if (fd.fd_id === action.payload.documentId) {
          fd.deactivated_because = action.payload
            .deactivatedBecause as DeactivatedSettingsKey
        }
      })
      return {
        ...state,
        deactivated_full_documents: updatedFullDocument,
      }
    }

    case InputMaskActionsEnum.CHANGE_LEGAL_ENTITY: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      let edited_writing_lines = [...state.edited_writing_lines]

      const analyticId = action.payload.analyticId

      if (analyticId !== undefined) {
        edited_writing_lines = state.edited_writing_lines.map((l) => {
          if (l.datum_type === "tax_excluded") {
            return { ...l, analytic_id: analyticId }
          }
          return l
        })
      }

      const newFullDocument = {
        ...state.edited_full_document,
        legal_entity_id: action.payload.legalEntity.id,
        merchant_id: action.payload.legalEntity.merchant_id,
        merchant_name: action.payload.legalEntity.merchant_name,
        merchant_code_id: action.payload.legalEntity.merchant_code_id,
        merchant_code: action.payload.legalEntity.merchant_code,
      }

      if (!action.payload.modifyLegalEntityForOtherInvoices) {
        const newFullDocs = state.full_documents_to_check.map((full_doc) => {
          if (full_doc.fd_id === state.edited_full_document?.fd_id) {
            return {
              ...full_doc,
              merchant_id: action.payload.legalEntity.merchant_id,
              legal_entity_id: action.payload.legalEntity.id,
              merchant_name: action.payload.legalEntity.merchant_name,
              merchant_code_id: action.payload.legalEntity.merchant_code_id,
              merchant_code: action.payload.legalEntity.merchant_code,
            }
          } else {
            return full_doc
          }
        })

        return {
          ...state,
          edited_full_document: newFullDocument,
          initial_full_document: newFullDocument,
          edited_writing_lines,
          full_documents_to_check: newFullDocs,
        }
      }

      const newFullDocs = state.full_documents_to_check.map((full_doc) => {
        if (
          full_doc.merchant_id === state.edited_full_document?.merchant_id &&
          full_doc.legal_entity_id ===
            state.edited_full_document.legal_entity_id
        ) {
          return {
            ...full_doc,
            merchant_id: action.payload.legalEntity.merchant_id,
            legal_entity_id: action.payload.legalEntity.id,
            merchant_name: action.payload.legalEntity.merchant_name,
            merchant_code_id: action.payload.legalEntity.merchant_code_id,
            merchant_code: action.payload.legalEntity.merchant_code,
          }
        } else {
          return full_doc
        }
      })
      return {
        ...state,
        edited_full_document: newFullDocument,
        initial_full_document: newFullDocument,
        full_documents_to_check: newFullDocs,
        edited_writing_lines,
      }
    }

    case InputMaskActionsEnum.CHANGE_MERCHANT: {
      if (!state.edited_full_document) {
        return { ...state }
      }
      if (!state.initial_full_document) {
        return { ...state }
      }

      const edited_writing_lines = state.edited_writing_lines.map((l) => {
        if (l.datum_type === "tax_excluded") {
          return { ...l, analytic_id: action.payload.analyticId }
        }
        return l
      })

      const newFullDocs = state.full_documents_to_check.map((full_doc) => {
        if (
          full_doc.merchant_id === state.edited_full_document?.merchant_id &&
          full_doc.legal_entity_id ===
            state.edited_full_document.legal_entity_id
        ) {
          return {
            ...full_doc,
            merchant_id: action.payload.merchantId,
            merchant_name: action.payload.merchantName,
            merchant_code_id: action.payload.merchantCodeId
              ? action.payload.merchantCodeId
              : state.edited_full_document.merchant_code_id,
            merchant_code: action.payload.merchantCode
              ? action.payload.merchantCode
              : state.edited_full_document.merchant_code,
          }
        } else {
          return full_doc
        }
      })
      const initialFullDocument = {
        ...state.initial_full_document,
        merchant_id: action.payload.merchantId,
        merchant_name: action.payload.merchantName,
        merchant_code_id: action.payload.merchantCodeId
          ? action.payload.merchantCodeId
          : state.edited_full_document.merchant_code_id,
        merchant_code: action.payload.merchantCode
          ? action.payload.merchantCode
          : state.edited_full_document.merchant_code,
      }
      const newFullDocument = {
        ...state.edited_full_document,
        merchant_id: action.payload.merchantId,
        merchant_name: action.payload.merchantName,
        merchant_code_id: action.payload.merchantCodeId
          ? action.payload.merchantCodeId
          : state.edited_full_document.merchant_code_id,
        merchant_code: action.payload.merchantCode
          ? action.payload.merchantCode
          : state.edited_full_document.merchant_code,
      }
      return {
        ...state,
        initial_full_document: initialFullDocument,
        edited_full_document: newFullDocument,
        full_documents_to_check: newFullDocs,
        edited_writing_lines,
      }
    }

    case InputMaskActionsEnum.CHANGE_MERCHANT_CODE: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      const newFullDocs = state.full_documents_to_check.map((full_doc) => {
        if (full_doc.merchant_id === state.edited_full_document?.merchant_id) {
          return {
            ...full_doc,
            merchant_code_id:
              action.payload.merchantCodeId || full_doc.merchant_code_id,
            merchant_code: action.payload.merchantCode,
          }
        } else {
          return full_doc
        }
      })

      const newFullDocument = {
        ...state.edited_full_document,
        merchant_code_id:
          action.payload.merchantCodeId ||
          state.edited_full_document.merchant_code_id,
        merchant_code: action.payload.merchantCode,
      }
      return {
        ...state,
        edited_full_document: newFullDocument,
        full_documents_to_check: newFullDocs,
      }
    }

    case InputMaskActionsEnum.CHANGE_TYPOLOGY: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      let newFullDocument = {
        ...state.edited_full_document,
        document_type: action.payload.documentType,
        buy_or_sell: action.payload.buyOrSell,
      }

      if (action.payload.documentType === "bill_of_exchange") {
        newFullDocument = {
          ...state.edited_full_document,
          document_type: action.payload.documentType,
          goods_or_services: "services",
          document_source: "fr",
          buy_or_sell: "buy",
        }

        const taxIncludedLine = [
          ...state.edited_writing_lines,
        ].pop() as WritingLinePayload
        const newLineUuid = uuidv4()

        const newWritingLines: WritingLinePayload[] = [
          {
            account:
              state.all_company_accounts?.buy
                ?.tax_excluded_bill_of_exchange[0] || null,
            writing_line_uuid: newLineUuid,
            amount: "0",
            currency_code: taxIncludedLine?.currency_code || "EUR",
            exchange_rate: taxIncludedLine?.exchange_rate || null,
            exchange_rate_date: taxIncludedLine?.exchange_rate_date || null,
            currency_amount: taxIncludedLine?.currency_amount || null,
            datum_type: "tax_excluded_bill_of_exchange",
            direction: "debit",
            vat_rate: "",
            source: "input_mask",
            merchant_code_id: null,
            is_fuel_vat_line: false,
            partial_vat_recovery_percentage: null,
            unit: { id: null },
            unit_quantity: null,
            unit_description: null,
            unit_2: { id: null },
            unit_2_quantity: null,
            unit_2_description: null,
            analytic_id: null,
            new_analytic_value: null,
          },
          {
            account:
              state.all_company_accounts?.buy
                ?.tax_included_bill_of_exchange[0] || null,
            writing_line_uuid: newLineUuid,
            amount: "0",
            currency_code: taxIncludedLine?.currency_code || "EUR",
            exchange_rate: taxIncludedLine?.exchange_rate || null,
            exchange_rate_date: taxIncludedLine?.exchange_rate_date || null,
            currency_amount: taxIncludedLine?.currency_amount || null,
            datum_type: "tax_included_bill_of_exchange",
            direction: "credit",
            vat_rate: "",
            source: "input_mask",
            merchant_code_id: null,
            is_fuel_vat_line: false,
            partial_vat_recovery_percentage: null,
            unit: { id: null },
            unit_quantity: null,
            unit_description: null,
            unit_2: { id: null },
            unit_2_quantity: null,
            unit_2_description: null,
            analytic_id: null,
            new_analytic_value: null,
          },
        ]

        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: newWritingLines,
        }
      }

      if (action.payload.buyOrSell !== state.edited_full_document.buy_or_sell) {
        const newWritingLines = changeBuyOrSell({
          taxIncludedAccount:
            state.all_company_accounts?.[action.payload.buyOrSell]
              ?.tax_included[0],
          direction:
            action.payload.documentType === "invoice"
              ? action.payload.buyOrSell === "buy"
                ? "credit"
                : "debit"
              : action.payload.buyOrSell === "buy" // credit_note
              ? "debit"
              : "credit",
          currencyCode: state.edited_writing_lines[0].currency_code,
          exchange_rate: state.edited_writing_lines[0].exchange_rate,
          exchange_rate_date: state.edited_writing_lines[0].exchange_rate_date,
          currency_amount: state.edited_writing_lines[0].currency_amount,
        }).filter(
          (wl) =>
            !billOfExchangeDatumTypes.some(
              (billOfExchangeDatumType) =>
                billOfExchangeDatumType === wl.datum_type
            )
        )
        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: newWritingLines,
        }
      } else if (
        action.payload.documentType !== state.edited_full_document.document_type
      ) {
        const buyOrSell = state.edited_full_document?.buy_or_sell || "buy"
        const newWritingLines = changeDocumentType({
          currentWritingLines: state.edited_writing_lines,
          accounts:
            state.all_company_accounts && state.all_company_accounts[buyOrSell],
          buyOrSell,
          documentType: action.payload.documentType,
        }).filter(
          (wl) =>
            !billOfExchangeDatumTypes.some(
              (billOfExchangeDatumType) =>
                billOfExchangeDatumType === wl.datum_type
            )
        )
        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: newWritingLines,
        }
      }
      return {
        ...state,
        edited_full_document: newFullDocument,
      }
    }

    case InputMaskActionsEnum.CHANGE_BILL_OF_EXCHANGE_MERCHANT: {
      const modifiedLines = copyObject(state.edited_writing_lines)

      modifiedLines.forEach((l, index) => {
        if (
          l.writing_line_uuid ===
            action.payload.writingLine.writing_line_uuid &&
          l.datum_type === action.payload.writingLine.datum_type
        ) {
          modifiedLines[index].merchant_code_id =
            action.payload.newMerchantCodeId
        }
      })

      return { ...state, edited_writing_lines: modifiedLines }
    }

    case InputMaskActionsEnum.CHANGE_ACCOUNT: {
      const modifiedLines = copyObject(state.edited_writing_lines)

      modifiedLines.forEach((l, index) => {
        if (
          l.writing_line_uuid ===
            action.payload.writingLine.writing_line_uuid &&
          l.datum_type === action.payload.writingLine.datum_type
        ) {
          modifiedLines[index].account = action.payload.newAccount
        }
      })

      if (
        state.initial_writing_lines.some(
          (l) =>
            l.writing_line_uuid === action.payload.writingLine.writing_line_uuid
        ) &&
        isMagicCheckBoxDatumType(action.payload.writingLine.datum_type) &&
        !state.magic_checkbox[action.payload.writingLine.datum_type]
          ?.writing_line_uuid
      ) {
        return {
          ...state,
          edited_writing_lines: modifiedLines,
          magic_checkbox: {
            ...state.magic_checkbox,
            [action.payload.writingLine.datum_type]: {
              writing_line_uuid: action.payload.writingLine.writing_line_uuid,
            },
          },
        }
      }

      return {
        ...state,
        edited_writing_lines: modifiedLines,
      }
    }

    case InputMaskActionsEnum.CHANGE_GOODS_OR_SERVICES: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      if (state.edited_full_document.document_type === "bill_of_exchange") {
        return {
          ...state,
        }
      }

      const newFullDocument = {
        ...state.edited_full_document,
        goods_or_services: action.payload,
      }

      if (
        action.payload !== state.edited_full_document.goods_or_services &&
        action.payload === "on_site_consumption"
      ) {
        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: state.edited_writing_lines.filter(
            (l) => !l.datum_type.includes("vat")
          ),
        }
      }

      const newWritingLines = updateGoodsOrServiceAndSourceLines({
        all_company_accounts: state.all_company_accounts,
        vat_accounts: state.vat_accounts,
        buy_or_sell: state.edited_full_document?.buy_or_sell || "buy",
        goods_or_services: action.payload,
        source: state.edited_full_document.document_source,
        edited_writing_lines: state.edited_writing_lines,
      })
      if (action.payload !== state.edited_full_document.goods_or_services) {
        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: newWritingLines,
        }
      }
      return {
        ...state,
        edited_full_document: newFullDocument,
      }
    }

    case InputMaskActionsEnum.CHANGE_WRITING_LINE_ANALYTICS: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      const new_edited_writing_lines = state.edited_writing_lines.map((l) => {
        if (
          l.writing_line_uuid ===
            action.payload.writingLine.writing_line_uuid &&
          ["tax_excluded", "custom"].includes(l.datum_type)
        ) {
          return {
            ...l,
            analytic_id: action.payload.selectedAnalyticsId,
            new_analytic_value: action.payload.newAnalyticsValue,
          }
        }
        return l
      })
      return { ...state, edited_writing_lines: new_edited_writing_lines }
    }

    case InputMaskActionsEnum.RESET_NEW_ANALYTIC_VALUES: {
      const new_edited_writing_lines = state.edited_writing_lines.map((l) => {
        if (l.new_analytic_value && l.new_analytic_value.trim() !== "") {
          const matchingAnalytic = action.payload.analytics.find(
            (analytic) => analytic.field_value_1 === l.new_analytic_value
          )
          if (matchingAnalytic) {
            return {
              ...l,
              new_analytic_value: null,
              analytic_id: matchingAnalytic.id,
            }
          }
        }
        return {
          ...l,
          new_analytic_value: null,
        }
      })

      const new_initial_writing_lines = state.initial_writing_lines.map(
        (l, index) => {
          const correspondingEditedLine = new_edited_writing_lines[index]
          if (
            correspondingEditedLine &&
            correspondingEditedLine.analytic_id !== null &&
            correspondingEditedLine.analytic_id !== l.analytic_id
          ) {
            return {
              ...l,
              analytic_id: correspondingEditedLine.analytic_id,
              new_analytic_value: null,
            }
          }
          return {
            ...l,
            new_analytic_value: null,
          }
        }
      )

      const new_full_documents_to_check = state.full_documents_to_check.map(
        (fd) => {
          if (fd.fd_id === state.edited_full_document?.fd_id) {
            return {
              ...fd,
              writing_lines: new_edited_writing_lines,
            }
          }
          return fd
        }
      )

      return {
        ...state,
        edited_writing_lines: new_edited_writing_lines,
        initial_writing_lines: new_initial_writing_lines,
        full_documents_to_check: new_full_documents_to_check,
      }
    }

    case InputMaskActionsEnum.CHANGE_DOCUMENT_SOURCE: {
      if (!state.edited_full_document) {
        return { ...state }
      }

      if (state.edited_full_document.document_type === "bill_of_exchange") {
        return {
          ...state,
        }
      }

      const newFullDocument = {
        ...state.edited_full_document,
        document_source: action.payload.documentSource,
      }

      if (
        action.payload.documentSource !==
        state.edited_full_document.document_source
      ) {
        const taxIncludedAccountId =
          state.edited_full_document.buy_or_sell === "sell"
            ? action.payload.company.sell_third_party_account_id
            : action.payload.company.buy_third_party_account_id

        const taxIncludedAccount = state.all_company_accounts?.[
          state.edited_full_document.buy_or_sell
        ]?.tax_included.find((a) => a.id === taxIncludedAccountId)

        const newWritingLines = changeBuyOrSell({
          taxIncludedAccount,
          direction:
            state.edited_full_document.buy_or_sell === "buy"
              ? "credit"
              : "debit",
          currencyCode: state.edited_writing_lines[0].currency_code,
          exchange_rate: state.edited_writing_lines[0].exchange_rate,
          exchange_rate_date: state.edited_writing_lines[0].exchange_rate_date,
          currency_amount: state.edited_writing_lines[0].currency_amount,
        })

        return {
          ...state,
          edited_full_document: newFullDocument,
          edited_writing_lines: newWritingLines,
        }
      }

      return { ...state }
    }

    case InputMaskActionsEnum.TOGGLE_BLOCKED_BY_ALREADY_TAKEN_MERCHANT_CODE: {
      return {
        ...state,
        blockedByAlreadyTakenMerchantCode:
          action.payload.blockedByAlreadyTakenMerchantCode,
      }
    }

    case InputMaskActionsEnum.SET_DISPLAY_INPUT_MASK_MODAL: {
      return {
        ...InputMaskInitialState,
        displayInputMaskModal: action.payload.displayInputMaskModal,
        selectedTab: action.payload.selectedTab,
        isDatePickerOpen: false,
      }
    }
    case InputMaskActionsEnum.CAN_CLOSE_INPUT_MASK_MODAL: {
      return {
        ...state,
        canCloseInputMaskModal: action.payload.canCloseInputMaskModal,
      }
    }

    case InputMaskActionsEnum.SET_IS_DATE_PICKER_OPEN: {
      return {
        ...state,
        isDatePickerOpen: action.payload.isDatePickerOpen,
      }
    }
    case InputMaskActionsEnum.SET_SAVED_DATE_PICKER_VALUE: {
      return {
        ...state,
        savedDatePicker: {
          param: action.payload.param,
          value: action.payload.value,
        },
      }
    }
    case InputMaskActionsEnum.RESET_SAVED_DATE_PICKER_VALUE: {
      return {
        ...state,
        savedDatePicker: null,
      }
    }

    case InputMaskActionsEnum.FOCUS_LINE: {
      return {
        ...state,
      }
    }

    case InputMaskActionsEnum.EXPAND_ALL_INVOICES: {
      return {
        ...state,
        expandInvoicesList: "expanded",
      }
    }
    case InputMaskActionsEnum.MINIMIZE_ALL_INVOICES: {
      return {
        ...state,
        expandInvoicesList: "minimized",
      }
    }

    case InputMaskActionsEnum.STORE_CONTEXT: {
      return {
        ...state,
        ...action.payload,
      }
    }

    case InputMaskActionsEnum.MERCHANT_INSTRUCTION_SUCCESS: {
      return {
        ...state,
        magic_checkbox: {
          vat: null,
          tax_excluded: null,
        },
      }
    }

    case InputMaskActionsEnum.MERCHANT_INSTRUCTION_ERROR: {
      return {
        ...state,
        magic_checkbox: {
          vat: null,
          tax_excluded: null,
        },
      }
    }

    case InputMaskActionsEnum.SET_MERCHANT_INSTRUCTION: {
      return {
        ...state,
        magic_checkbox: {
          ...state.magic_checkbox,
          [action.payload.datum_type]: {
            writing_line_uuid: action.payload.writing_line_uuid,
            merchant_instruction: action.payload.merchant_instruction,
          },
        },
      }
    }

    case InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_SUCCESS:
      const nextFullDocumentIndex =
        state.full_documents_to_check.findIndex(
          (fd) => fd.fd_id === action.fullDocumentId
        ) + 1
      const nextFullDocumentId =
        nextFullDocumentIndex > 0
          ? state.full_documents_to_check[nextFullDocumentIndex]?.fd_id
          : undefined

      return {
        ...state,
        deactivate_status: "success",
        nextSelectedFullDocumentId: nextFullDocumentId,
      }

    case InputMaskActionsEnum.DEACTIVATE_FULL_DOCUMENT_RESET:
      return { ...state, deactivate_status: "idle" }

    case InputMaskActionsEnum.REACTIVATE_DOCUMENT:
      const deactivatedDocument = state.deactivated_full_documents.find(
        (d) => d.fd_id === action.payload.fd_id
      )
      if (!deactivatedDocument) {
        return { ...state, urlForFullDocumentStatus: "idle" }
      }
      const full_document: FullDocumentOnly = {
        documents: [...deactivatedDocument.documents],
        fd_id: deactivatedDocument?.fd_id,
        document_type: "invoice",
        buy_or_sell: "buy",
        fd_status: "",
        journal_code: "",
        journal_id: null,
        display_url: "",
        periodicity_date_end: null,
        periodicity_date_start: null,
        fd_document_date: "",
        fd_document_due_date: null,
        fd_document_reference: null,
        fd_automatic_reference: null,
        legal_entity_id: 0,
        fd_user_file_name: "",
        original_file_name: deactivatedDocument?.original_batch_name || "",
        merchant_code: "",
        merchant_code_id: 0,
        merchant_name: "",
        merchant_id: 0,
        merchant_buy_default_account_id: null,
        merchant_buy_vat_default_account_id: null,
        merchant_sell_default_account_id: null,
        merchant_sell_vat_default_account_id: null,
        goods_or_services: null,
        document_source: null,
        previously_deactivated_because: deactivatedDocument.deactivated_because,
        free_text_full_doc: null,
        merchant_code_to_create: "",
        ocr_ttc: deactivatedDocument.ocr_ttc,
        payment_method: "",
        full_document_file_name: deactivatedDocument.full_document_file_name,
      }

      const writing_lines = generateEmptyTaxIncluded({
        currency: state.currency,
      })
      return {
        ...state,
        urlForFullDocumentStatus: "idle",
        selectedTab: "processed",
        deactivated_full_documents: state.deactivated_full_documents.map(
          (d) => {
            if (d.fd_id === full_document.fd_id) {
              return { ...d, is_being_reactivated: true }
            }
            return d
          }
        ),
        full_documents_to_check: [
          ...state.full_documents_to_check,
          {
            ...full_document,
            writing_lines: writing_lines,
          },
        ],
        initial_full_document: full_document,
        edited_full_document: full_document,
        initial_writing_lines: writing_lines,
        edited_writing_lines: writing_lines,
        increased_cents: [],
        decreased_cents: [],
        magic_checkbox: {
          vat: null,
          tax_excluded: null,
        },
        impacted_documents: 0,
        selectedFullDocument: {
          ...full_document,
          writing_lines: [],
        },
      }
    case InputMaskActionsEnum.CANCEL_DOCUMENT_REACTIVATION:
      return {
        ...state,
        deactivated_full_documents: state.deactivated_full_documents.map(
          (d) => {
            return { ...d, is_being_reactivated: false }
          }
        ),
        full_documents_to_check: state.full_documents_to_check.filter(
          (fd) => fd.fd_id !== action.payload.fd_id
        ),
        selectedTab: "deactivated",
        initial_full_document: null,
        edited_full_document: null,
        initial_writing_lines: [],
        edited_writing_lines: [],
        selectedFullDocument: state.deactivated_full_documents.find(
          (d) => d.fd_id === action.payload.fd_id
        ) as DeactivatedDocumentInWritingForInputMask,
      }

    case InputMaskActionsEnum.RESET_ACCOUNT_TO_SELECT:
      return {
        ...state,
        accountIdToSelectFromCreation: null,
      }

    case InputMaskActionsEnum.SET_MERCHANT_CODE_TO_CREATE:
      if (!state.edited_full_document) {
        return { ...state }
      }

      return {
        ...state,
        edited_full_document: {
          ...state.edited_full_document,
          merchant_code_to_create: action.payload,
        },
      }

    case InputMaskActionsEnum.SAVE_SELECTED_DOCUMENT_FOR_REBIND:
      return {
        ...state,
        nextSelectedFullDocumentId:
          state.nextSelectedFullDocumentId ?? state.selectedFullDocument?.fd_id,
      }

    case InputMaskActionsEnum.RESET_NEXT_SELECTED_FULL_DOCUMENT_ID:
      return {
        ...state,
        nextSelectedFullDocumentId: undefined,
      }

    case InputMaskActionsEnum.UPDATE_FULL_DOCUMENT_FILE_NAME: {
      const fileNameMap = new Map(
        action.payload.fileNameList.map((item) => [item.id, item.file_name])
      )

      const updatedFullDocuments = state.full_documents_to_check.map((fd) => {
        const newFileName = fileNameMap.get(fd.fd_id)
        if (newFileName) {
          return { ...fd, full_document_file_name: newFileName }
        }
        return fd
      })

      const updatedDeactivatedFullDocuments =
        state.deactivated_full_documents.map((fd) => {
          const newFileName = fileNameMap.get(fd.fd_id)
          if (newFileName) {
            return { ...fd, full_document_file_name: newFileName }
          }
          return fd
        })

      const updatedSelectedFullDocument = state.selectedFullDocument
        ? {
            ...state.selectedFullDocument,
            full_document_file_name:
              fileNameMap.get(state.selectedFullDocument.fd_id) ||
              state.selectedFullDocument.full_document_file_name,
          }
        : null

      return {
        ...state,
        full_documents_to_check: updatedFullDocuments,
        deactivated_full_documents: updatedDeactivatedFullDocuments,
        selectedFullDocument: updatedSelectedFullDocument,
      }
    }

    default:
      return { ...state }
  }
}

export function InputMaskReducer(
  state = InputMaskInitialState,
  action: InputMaskActionsType
): InputMaskState {
  return withChangeFlags(inputMaskReducerInternal(state, action))
}

export const isAssigned = (
  selectedFullDocument:
    | FullDocumentForInputMask
    | DeactivatedDocumentInWritingForInputMask
    | null
): selectedFullDocument is FullDocumentForInputMask => {
  return (
    (selectedFullDocument as FullDocumentForInputMask)?.fd_status === "assigned"
  )
}

export type MainCurrencyCode = "EUR" | "XOF"

interface InputMaskResponse {
  full_documents_to_check: FullDocumentForInputMask[]
  deactivated_full_documents: DeactivatedDocumentInWritingForInputMask[]
  vat_accounts: VatAccountsWithRate[]
  can_add_free_text_full_doc: boolean
  allowed_vat_rates: number[]
  currency: MainCurrencyCode
  is_syscohada: boolean
  enable_user_pushback?: boolean
}

export const getInputMaskWritingThunk =
  ({ fiscalYearId, companyId }: { fiscalYearId: number; companyId: number }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInputMaskWritingAttemptAction())
    return axios
      .get<InputMaskResponse>("/full_documents/input_mask_from_writing", {
        params: {
          fiscal_year_id: fiscalYearId,
          company_id: companyId,
        },
      })
      .then(({ data }) => {
        dispatch(getInputMaskWritingSuccessAction(data))
        dispatch(
          storeContext({
            fiscalYearId,
            companyId,
            merchantId: null,
            writingArchiveId: null,
          })
        )
      })
      .catch((error: AxiosError) => {
        getInputMaskWritingErrorAction(error)
      })
  }

export const getInputMaskFullDocumentsThunk =
  ({
    fiscalYearId,
    companyId,
    fullDocumentsIds,
  }: {
    fiscalYearId: number
    companyId: number
    fullDocumentsIds: number[]
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInputMaskFullDocumentsAttemptAction())
    return axios
      .post<InputMaskResponse>(
        "/full_documents/input_mask_for_full_documents",
        {
          fiscal_year_id: fiscalYearId,
          company_id: companyId,
          full_documents_id: fullDocumentsIds.join(","),
        }
      )
      .then(({ data }) => {
        dispatch(getInputMaskFullDocumentsSuccessAction(data))
        dispatch(
          storeContext({
            fiscalYearId,
            companyId,
            merchantId: null,
            fullDocumentsIds,
            writingArchiveId: null,
          })
        )
      })
      .catch((error: AxiosError) => {
        getInputMaskFullDocumentsErrorAction(error)
      })
  }

type InputMaskMerchantResponse = {
  full_documents_to_check: FullDocumentForInputMask[]
  vat_accounts: VatAccountsWithRate[]
  can_add_free_text_full_doc: boolean
  allowed_vat_rates: number[]
  currency: MainCurrencyCode
  is_syscohada: boolean
  enable_user_pushback?: boolean
}

export const getInputMaskMerchantThunk =
  ({
    fiscalYearId,
    merchantId,
    companyId,
  }: {
    fiscalYearId: number
    merchantId: number
    companyId: number
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInputMaskMerchantAttemptAction())
    return axios
      .get<InputMaskMerchantResponse>(
        "/full_documents/input_mask_from_merchant",
        {
          params: {
            fiscal_year_id: fiscalYearId,
            merchant_id: merchantId,
            company_id: companyId,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getInputMaskMerchantSuccessAction(data))
        dispatch(
          storeContext({
            fiscalYearId,
            companyId,
            merchantId,
            writingArchiveId: null,
          })
        )
      })
      .catch((error: AxiosError) => {
        getInputMaskMerchantErrorAction(error)
      })
  }

export const getInputMaskFromWritingArchiveThunk =
  ({
    fiscalYearId,
    companyId,
    writingArchiveId,
  }: {
    fiscalYearId: number
    companyId: number
    writingArchiveId: number
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInputMaskWritingArchiveAttemptAction())
    return axios
      .get<InputMaskMerchantResponse>(
        "/full_documents/input_mask_from_writing_archive",
        {
          params: {
            fiscal_year_id: fiscalYearId,
            company_id: companyId,
            writing_archive_id: writingArchiveId,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getInputMaskWritingArchiveSuccessAction(data))
        dispatch(
          storeContext({
            fiscalYearId,
            companyId,
            merchantId: null,
            writingArchiveId,
          })
        )
      })
      .catch((error: AxiosError) => {
        getInputMaskWritingArchiveErrorAction(error)
      })
  }

export const getInputMaskDeactivatedThunk =
  ({
    fiscalYearId,
    companyId,
    deactivatedType,
    fullDocumentId,
  }: {
    fiscalYearId: number
    companyId: number
    deactivatedType: FileType
    fullDocumentId: number
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getInputMaskDeactivatedAttemptAction())
    return axios
      .get<InputMaskResponse>("/full_documents/input_mask_for_deactivated", {
        params: {
          fiscal_year_id: fiscalYearId,
          company_id: companyId,
          deactivated_type: deactivatedType,
        },
      })
      .then(({ data }) => {
        dispatch(getInputMaskDeactivatedSuccessAction(data, fullDocumentId))
        dispatch(
          storeContext({
            fiscalYearId,
            companyId,
            merchantId: null,
            deactivatedType: deactivatedType,
            writingArchiveId: null,
          })
        )
      })
      .catch((error: AxiosError) => {
        getInputMaskDeactivatedErrorAction(error)
      })
  }

export interface AllAccounts {
  tax_excluded: Account[]
  vat: Account[]
  tax_included: Account[]
  eu_vat: Account[]
  eu_reverse_vat: Account[]
  eu_goods_vat: Account[]
  eu_goods_reverse_vat: Account[]
  world_vat: Account[]
  world_reverse_vat: Account[]
  world_goods_vat: Account[]
  world_goods_reverse_vat: Account[]
  construction_vat: Account[]
  construction_reverse_vat: Account[]
  deposit: Account[]
  reverse_deposit: Account[]
  custom: Account[]
  tax_excluded_bill_of_exchange: Account[]
  tax_included_bill_of_exchange: Account[]
}

export const defaultAccounts: AllAccounts = {
  tax_excluded: [],
  vat: [],
  tax_included: [],
  eu_vat: [],
  eu_reverse_vat: [],
  eu_goods_vat: [],
  eu_goods_reverse_vat: [],
  world_vat: [],
  world_reverse_vat: [],
  world_goods_vat: [],
  world_goods_reverse_vat: [],
  construction_vat: [],
  construction_reverse_vat: [],
  deposit: [],
  reverse_deposit: [],
  custom: [],
  tax_excluded_bill_of_exchange: [],
  tax_included_bill_of_exchange: [],
}

export interface AutoliquidationVat {
  eu_vat: VatRateValue
  eu_goods_vat: VatRateValue
  world_vat: VatRateValue
  world_goods_vat: VatRateValue
  construction_vat: VatRateValue
}

interface InputMaskAccountsPayload {
  autoliquidation_vat_rates: AutoliquidationVat
  all_company_accounts: AllCompanyAccounts
  autoliquidated_custom_vat_rates: AutoliquidatedCustomVatRate[]
}

type AutoLiquidatedType =
  | "eu"
  | "construction"
  | "eu_goods"
  | "world"
  | "world_goods"

export interface AutoliquidatedCustomVatRate {
  autoliquidated_type: AutoLiquidatedType
  company_id: number
  created_at: string
  id: number
  reverse_vat_account_id: number
  user_id: number
  vat_account_id: number
  vat_rate_id: number
  rate: string
  vat_account_number: number
  vat_account_details: string
  reverse_vat_account_number: number
  reverse_vat_account_details: string
}

export interface AllCompanyAccounts {
  buy: AllAccounts
  sell: AllAccounts
}

export const getInputMaskAccountsThunk =
  ({ companyId }: { companyId: number }) =>
  (dispatch: Dispatch<AnyAction>) => {
    cancelBatchLoading()
    dispatch(getInputMaskAccountsAttemptAction())
    return axios
      .get<InputMaskAccountsPayload>("/accounts/get_input_mask_accounts", {
        params: {
          company_id: companyId,
        },
      })
      .then(({ data }) => {
        const payload = {
          autoliquidation_vat_rates: data.autoliquidation_vat_rates,
          all_company_accounts: {
            buy: data.all_company_accounts.buy,
            sell: data.all_company_accounts.sell,
          },
          autoliquidated_custom_vat_rates: data.autoliquidated_custom_vat_rates,
        }
        dispatch(getInputMaskAccountsSuccessAction(payload))
      })
      .catch((error: AxiosError) => {
        dispatch(getInputMaskAccountsErrorAction(error))
      })
  }

export const updateWritingLinesThunk =
  () =>
  (
    dispatch: Dispatch<AnyAction | RNBThunkAction>,
    getState: () => RootState
  ) => {
    dispatch(updateWritingLinesAttemptAction())

    const state = getState()
    const initialFullDocument = state.inputMask.initial_full_document
    const editedFullDocument = state.inputMask.edited_full_document
    const initialWritinglines = state.inputMask.initial_writing_lines
    const editedWritingLines = state.inputMask.edited_writing_lines
    const merchantsOfCompany = state.merchantCodes.merchantsOfCompany

    if (!initialFullDocument || !editedFullDocument) {
      return
    }

    const fullDocumentId = initialFullDocument.fd_id
    const changedMerchantCode = merchantsOfCompany.find(
      (mc) => mc.id === editedFullDocument.merchant_id
    )?.code
    const changedMerchantCodeId = merchantsOfCompany.find(
      (mc) => mc.id === editedFullDocument.merchant_id
    )?.code_id

    const merchantCodeId = changedMerchantCodeId || 0
    const merchantCode = changedMerchantCode || ""
    const writingLinesChanged = !R.equals(
      initialWritinglines,
      editedWritingLines
    )

    const formatedInitialWritingLines: WritingLine[] = initialWritinglines.map(
      (l) => ({
        ...l,
        vat_rate: Number(l.vat_rate) as VatRateValue,
      })
    )
    const formatedEditedWritingLines: WritingLine[] = editedWritingLines.map(
      (l) => ({
        ...l,
        vat_rate: Number(l.vat_rate) as VatRateValue,
      })
    )

    return axios
      .put<unknown>(
        `/full_documents/${fullDocumentId}/input_mask_recreate_writing_lines`,
        {
          merchant_code_id: merchantCodeId,
          merchant_code: merchantCode,
          initial_writing_lines: formatedInitialWritingLines,
          edited_writing_lines: formatedEditedWritingLines,
          initial_full_document: initialFullDocument,
          edited_full_document: editedFullDocument,
          writing_lines_have_changed: writingLinesChanged,
        }
      )
      .then(() => {
        const hasNewAnalyticValues = editedWritingLines.some(
          (line) =>
            line.new_analytic_value && line.new_analytic_value.trim() !== ""
        )

        dispatch(
          updateWritingLinesSuccessAction({
            editedWritingLines,
            editedFullDocument,
            fullDocumentId,
            merchantCodeId,
            merchantCode,
          })
        )

        if (hasNewAnalyticValues && getState().inputMask.companyId) {
          axios
            .get<Analytic[]>(`analytics/get_analytics`, {
              params: {
                company_id: getState().inputMask.companyId!,
              },
            })
            .then(({ data }) => {
              dispatch(resetNewAnalyticValues({ analytics: data }))
              dispatch(getAnalyticsSuccessAction(data))
            })
            .catch(() => {
              // Failed to fetch analytics
            })
        }

        if (
          getState().inputMask.edited_full_document?.merchant_code_id !==
            merchantCodeId &&
          getState().inputMask.companyId
        ) {
          dispatch(
            GetAllMerchantsOfCompanyForCodes(
              getState().inputMask.companyId || 0
            )
          )
        }

        const taxExcludedMerchantInstruction =
          getState().inputMask.magic_checkbox.tax_excluded?.merchant_instruction
        if (taxExcludedMerchantInstruction) {
          dispatch(giveMerchantInstructionThunk(taxExcludedMerchantInstruction))
        }

        const vatMerchantInstruction =
          getState().inputMask.magic_checkbox.vat?.merchant_instruction
        if (vatMerchantInstruction) {
          dispatch(giveMerchantInstructionThunk(vatMerchantInstruction))
        }
      })
      .catch((error: AxiosError<{ error: string }>) => {
        if (
          error.response?.data?.error.includes(
            "Ce merchant est paramétré sans TVA"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-vat-${initialFullDocument.buy_or_sell}.title`,
              bodyKey: `input-mask.toaster.error-vat-${initialFullDocument.buy_or_sell}.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "Document reference must be present for sell"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-sell-reference.title`,
              bodyKey: `input-mask.toaster.error-sell-reference.body`,
            })
          )
        } else if (
          error.response?.data.error.includes("Incoherent buy_or_sell")
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-buy-or-sell.title`,
              bodyKey:
                editedFullDocument.buy_or_sell === "buy"
                  ? `input-mask.toaster.error-buy.body`
                  : `input-mask.toaster.error-sell.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "vat is not compatible with tax excluded"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-vat-incompatible-with-tax-excluded.title`,
              bodyKey: `input-mask.toaster.error-vat-incompatible-with-tax-excluded.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "Cette référence existe déjà en vente"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-sell-duplicate-reference.title`,
              bodyKey: `input-mask.toaster.error-sell-duplicate-reference.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "Impossible de sauvegarder : Ce code fournisseur"
          )
        ) {
          const message = error.response.data.error
            .split("sauvegarder : ")[1]
            .split(" :si")[0]
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-code-already-used.title`,
              bodyKey: message,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "DocumentAssignManager::BadReverseDeposit"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-bad-reverse-deposit.title`,
              bodyKey: `input-mask.toaster.error-bad-reverse-deposit.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "there is more than one writing_line with a balance account"
          ) ||
          error.response?.data.error.includes(
            "cannot find any writing_line with a balance account"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-bad-balance.title`,
              bodyKey: `input-mask.toaster.error-bad-balance.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "Date d'échéance antérieure à la date de facture"
          )
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.error-incoherent-dates.title`,
              bodyKey: `input-mask.toaster.error-incoherent-dates.body`,
            })
          )
        } else if (
          error.response?.data.error.includes(
            "DocumentEntryManager::IncorrectDate"
          ) ||
          error.response?.data.error.includes("Le document est trop vieux")
        ) {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: `input-mask.toaster.incorrect-date.title`,
              bodyKey: `input-mask.toaster.incorrect-date.body`,
            })
          )
        } else if (
          error.response?.data.error.includes("Code") &&
          error.response?.data.error.includes("is too long")
        ) {
          const regex = /Code (\w+) is too long, length is (\d+) limit is (\d+)/
          const match = error.response?.data.error.match(regex)

          let titleKey = "input-mask.toaster.error.title"
          let bodyKey = "input-mask.toaster.error.body"
          let bodyValues = {}

          if (match) {
            titleKey = "input-mask.toaster.error-code-too-long.title"
            bodyKey = "input-mask.toaster.error-code-too-long.body"
            bodyValues = { code: match[1], length: match[2], limit: match[3] }
          }

          dispatch(
            updateWritingLinesErrorAction({
              titleKey,
              bodyKey,
              bodyValues,
            })
          )
        } else {
          dispatch(
            updateWritingLinesErrorAction({
              titleKey: "input-mask.toaster.error.title",
              bodyKey: "input-mask.toaster.error.body",
            })
          )
        }
      })
  }

interface HistoryLine {
  created_at: string
  email: string
  full_document_id: number
  initial_full_document: FullDocumentOnly | null
  edited_full_document: FullDocumentOnly | null
  initial_writing_lines: WritingLine[]
  edited_writing_lines: WritingLine[]
}

export const getHistoryThunk =
  ({ fullDocumentId }: { fullDocumentId: number }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getHistoryAttemptAction())
    return axios
      .get<HistoryLine[]>("/full_documents/input_mask_history", {
        params: { full_document_id: fullDocumentId },
      })
      .then(({ data }) => {
        const history_modifications = data
          .map((historyLine) => {
            return [
              ...getWritingLineChanges({
                initial_writing_lines: historyLine.initial_writing_lines,
                edited_writing_lines: historyLine.edited_writing_lines,
                created_at: historyLine.created_at,
                email: historyLine.email,
              }),
              ...getFullDocumentModification({
                initial_full_document: historyLine.initial_full_document,
                edited_full_document: historyLine.edited_full_document,
                initial_writing_lines: historyLine.initial_writing_lines,
                edited_writing_lines: historyLine.edited_writing_lines,
                created_at: historyLine.created_at,
                email: historyLine.email,
              }),
            ]
          })
          .flat()
        dispatch(
          getHistorySuccessAction({
            history_modifications,
          })
        )
      })
      .catch((error: AxiosError) => {
        dispatch(getHistoryErrorAction(error))
      })
  }

export interface GiveMerchantInstructionPayload {
  instruction: InstructionType
  merchantId: number
  payload: MerchantInstructionPayload
  buyOrSell: buyOrSell
}

export const giveMerchantInstructionThunk =
  ({
    instruction,
    merchantId,
    payload,
    buyOrSell,
  }: GiveMerchantInstructionPayload) =>
  (dispatch: Dispatch<AnyAction>) =>
    axios
      .put("/merchants/give_merchant_instruction", {
        id: merchantId,
        merchant: { ...payload, instruction_type: instruction },
      })
      .then(() => {
        dispatch(merchantInstructionSuccess({ buyOrSell }))
      })
      .catch((error) => {
        if (error.request && error.response.data && error.response.data.error) {
          const message = error.response.data.error
          if (message.includes("est défini par défaut")) {
            dispatch(BanLockedAccountFailure())
            return
          }
          if (message.includes("est interdit")) {
            dispatch(LockBannedAccountFailure())
            return
          }
          if (message.includes("Deactivated account")) {
            dispatch(DeactivatedAccountFailure())
            return
          }
          if (message.includes("Spaces in the beginning or the end")) {
            dispatch(EditMerchantNameFailure("space"))
            return
          }
          if (message.includes("character-unauthorized")) {
            return dispatch(EditMerchantNameFailure("character"))
          }

          dispatch(merchantInstructionError({ buyOrSell }))
        }
      })

export const getInputMaskMerchantImpactedDocuments =
  ({
    companyId,
    legalEntityId,
  }: {
    companyId: number
    legalEntityId: number
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    if (!legalEntityId) {
      return new Promise(() => {})
    }
    dispatch(getMerchantImpactedDocumentsAttemptAction())
    return axios
      .get<{ impacted_documents: number }>(
        "/full_documents/input_mask_merchant_impacted_documents",
        {
          params: {
            company_id: companyId,
            legal_entity_id: legalEntityId,
          },
        }
      )
      .then(({ data }) => {
        dispatch(getMerchantImpactedDocumentsSuccessAction(data))
      })
      .catch((error: AxiosError) => {
        dispatch(getMerchantImpactedDocumentsErrorAction(error))
      })
  }

export const inputMaskDeactivateFullDocumentThunk =
  ({
    fullDocumentId,
    deactivatedBecause,
  }: {
    fullDocumentId: number
    deactivatedBecause: string
  }) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(deactivateFullDocumentAttemptAction())
    return axios
      .put(`/full_documents/${fullDocumentId}/input_mask_deactivate`, {
        deactivated_because: deactivatedBecause,
      })
      .then(() => {
        dispatch(deactivateFullDocumentSuccessAction({ fullDocumentId }))
      })
      .catch((error: AxiosError) => {
        dispatch(deactivateFullDocumentErrorAction(error))
      })
  }

export type InputMaskReportIssueRow = {
  id: number
  created_at: string
  message: string
  user_email: string
  processed_at: string | null
}

export const getUrlForFullDocumentInputMaskThunk =
  (fullDocumentId: number, delay: number = 500) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchUrlForFullDocument())
    return new Promise<void>((resolve, reject) => {
      const makeRequest = () => {
        axios
          .get<string>("/full_documents/get_url_for_full_document", {
            params: { id: fullDocumentId },
          })
          .then((response) => {
            const url = response.data
            dispatch(updateUrlForFullDocument(url))
            const now = Date.now()
            dispatch(
              setDocumentUrlCache({
                documentId: fullDocumentId,
                entry: {
                  status: "success",
                  url,
                  fetchedAt: now,
                  expiresAt: now + 3600000,
                },
              })
            )
            resolve()
          })
          .catch(() => {
            dispatch(errorUrlForFullDocument())
            reject()
          })
      }

      if (delay > 0) {
        setTimeout(makeRequest, delay)
      } else {
        makeRequest()
      }
    })
  }

const pendingUrlRequestsRef = new Set<number>()

const inFlightPromisesRef = new Map<number, Promise<string>>()

// Presigned URLs typically expire after 1 hour (3600000ms), but we refresh 5 minutes before
const PRESIGNED_URL_EXPIRY_MS = 3600000
const PRESIGNED_URL_REFRESH_BEFORE_EXPIRY_MS = 5 * 60 * 1000

export const fetchUrlIfNeededThunk =
  (fullDocumentId: number) =>
  (
    dispatch: Dispatch<AnyAction>,
    getState: () => { inputMask: InputMaskState }
  ) => {
    const state = getState().inputMask
    const cacheEntry = state.fullDocumentUrlsById[fullDocumentId]

    // Check if we have a valid cached URL
    if (cacheEntry) {
      const now = Date.now()
      const isExpired =
        cacheEntry.expiresAt &&
        cacheEntry.expiresAt <= now + PRESIGNED_URL_REFRESH_BEFORE_EXPIRY_MS
      const isValid =
        cacheEntry.status === "success" && cacheEntry.url && !isExpired

      if (isValid) {
        return Promise.resolve(cacheEntry.url!)
      }

      // If already loading, return the existing promise
      if (
        cacheEntry.status === "loading" &&
        inFlightPromisesRef.has(fullDocumentId)
      ) {
        return inFlightPromisesRef.get(fullDocumentId)!
      }
    }

    // Check if request is already in flight
    if (inFlightPromisesRef.has(fullDocumentId)) {
      return inFlightPromisesRef.get(fullDocumentId)!
    }

    // Set loading state
    dispatch(
      setDocumentUrlCache({
        documentId: fullDocumentId,
        entry: {
          status: "loading",
          url: cacheEntry?.url,
          fetchedAt: Date.now(),
        },
      })
    )

    // Create the fetch promise
    const fetchPromise = new Promise<string>((resolve, reject) => {
      axios
        .get<string>("/full_documents/get_url_for_full_document", {
          params: { id: fullDocumentId },
        })
        .then((response) => {
          const url = response.data
          const now = Date.now()
          const expiresAt = now + PRESIGNED_URL_EXPIRY_MS

          dispatch(
            setDocumentUrlCache({
              documentId: fullDocumentId,
              entry: {
                status: "success",
                url,
                fetchedAt: now,
                expiresAt,
              },
            })
          )

          inFlightPromisesRef.delete(fullDocumentId)
          resolve(url)
        })
        .catch((error) => {
          const isPdfGenerating =
            error.response?.status === 422 &&
            error.response?.data?.error ===
              "Document is being generated, please try again later"

          dispatch(
            setDocumentUrlCache({
              documentId: fullDocumentId,
              entry: {
                status: isPdfGenerating ? "generating" : "failure",
                url: undefined,
                fetchedAt: Date.now(),
              },
            })
          )

          inFlightPromisesRef.delete(fullDocumentId)
          reject(error)
        })
    })

    inFlightPromisesRef.set(fullDocumentId, fetchPromise)
    return fetchPromise
  }

export const setSelectedFullDocumentThunk =
  (
    selectedFullDocument:
      | FullDocumentForInputMask
      | DeactivatedDocumentInWritingForInputMask
      | null,
    nextDocumentId?: number
  ) =>
  (dispatch: Dispatch<AnyAction | RNBThunkAction>) => {
    dispatch(setSelectedFullDocument(selectedFullDocument))

    if (selectedFullDocument?.fd_id) {
      if (
        !selectedFullDocument.display_url &&
        !pendingUrlRequestsRef.has(selectedFullDocument.fd_id)
      ) {
        pendingUrlRequestsRef.add(selectedFullDocument.fd_id)
        getUrlForFullDocumentInputMaskThunk(
          selectedFullDocument.fd_id,
          0
        )(dispatch)
          .then(() => {
            pendingUrlRequestsRef.delete(selectedFullDocument.fd_id)
          })
          .catch(() => {
            pendingUrlRequestsRef.delete(selectedFullDocument.fd_id)
          })
      }
    }
  }

export const reloadInputMaskAfterRebindThunk =
  (): RNBThunkAction =>
  (
    dispatch: Dispatch<AnyAction | RNBThunkAction>,
    getState: () => RootState
  ) => {
    dispatch(saveSelectedDocumentForRebindAction())

    const state = getState().inputMask
    const rebindContext = getState().userRebinds.rebind_context
    const {
      merchantId,
      companyId,
      fiscalYearId,
      fullDocumentsIds,
      writingArchiveId,
    } = state

    const rebindFullDocumentsIds =
      rebindContext && rebindContext.documents_in_full_docs
        ? rebindContext.documents_in_full_docs
            .flat()
            .map((doc) => doc.full_document_id)
        : []

    const newFullDocumentsIds = [
      ...new Set([...fullDocumentsIds, ...rebindFullDocumentsIds]),
    ]

    if (!companyId || !fiscalYearId) {
      return Promise.resolve()
    }

    if (merchantId && companyId && fiscalYearId) {
      dispatch(
        getInputMaskMerchantThunk({
          merchantId,
          companyId,
          fiscalYearId,
        })
      )
    } else if (
      writingArchiveId != null &&
      writingArchiveId > 0 &&
      companyId &&
      fiscalYearId
    ) {
      dispatch(
        getInputMaskFromWritingArchiveThunk({
          fiscalYearId,
          companyId,
          writingArchiveId,
        })
      )
    } else if (fullDocumentsIds.length > 0 && fiscalYearId) {
      dispatch(
        getInputMaskFullDocumentsThunk({
          fiscalYearId,
          companyId,
          fullDocumentsIds: newFullDocumentsIds,
        })
      )
    } else if (companyId && fiscalYearId) {
      dispatch(
        getInputMaskWritingThunk({
          companyId,
          fiscalYearId,
        })
      )
    }

    dispatch(getInputMaskAccountsThunk({ companyId }))
    dispatch(GetCompanyMerchantCodesDataThunk(companyId))
    dispatch(GetAllMerchantsOfCompanyForCodes(companyId))

    return Promise.resolve()
  }

export const inputMaskUserWritingPushbackThunk =
  ({
    companyId,
    fiscalYearId,
    fullDocumentIds,
  }: {
    companyId: number
    fiscalYearId: number
    fullDocumentIds: number[]
  }): RNBThunkAction =>
  (
    dispatch: Dispatch<AnyAction | RNBThunkAction>,
    getState: () => RootState
  ) => {
    return axios
      .put<{ status: string }>(
        "/full_documents/input_mask_user_writing_pushback",
        {
          company_id: companyId,
          full_document_ids: fullDocumentIds,
        }
      )
      .then(() => {
        showDefaultSuccessToaster({
          type: "INPUT_MASK_USER_WRITING_PUSHBACK_SUCCESS",
          withToast: true,
          message: {
            titleKey: "input-mask.pushback.toast.success.title",
            bodyKey: "input-mask.pushback.toast.success.body",
          },
        })

        const state = getState().inputMask
        const { merchantId, fullDocumentsIds } = state
        const cid = state.companyId ?? companyId
        const fy = state.fiscalYearId ?? fiscalYearId

        if (merchantId && cid && fy) {
          dispatch(
            getInputMaskMerchantThunk({
              merchantId,
              companyId: cid,
              fiscalYearId: fy,
            })
          )
        } else if (fullDocumentsIds.length > 0 && cid && fy) {
          dispatch(
            getInputMaskFullDocumentsThunk({
              fiscalYearId: fy,
              companyId: cid,
              fullDocumentsIds,
            })
          )
        } else if (cid && fy) {
          dispatch(
            getInputMaskWritingThunk({
              companyId: cid,
              fiscalYearId: fy,
            })
          )
        }

        dispatch(getInputMaskAccountsThunk({ companyId: cid }))
        dispatch(GetCompanyMerchantCodesDataThunk(cid))
        dispatch(GetAllMerchantsOfCompanyForCodes(cid))
      })
      .catch((error: AxiosError<{ error?: string }>) => {
        const status = error.response?.status
        const bodyKey =
          status === 403
            ? "input-mask.pushback.toast.error.feature-disabled"
            : "input-mask.pushback.toast.error.body"
        showDefaultErrorToaster({
          type: "INPUT_MASK_USER_WRITING_PUSHBACK_ERROR",
          withToast: true,
          message: {
            titleKey: "input-mask.pushback.toast.error.title",
            bodyKey,
          },
        })
        throw error
      })
  }

export const updateJournalThunk =
  (fullDocumentId: number, journalId: number | null) =>
  (_dispatch: Dispatch<AnyAction>) => {
    return axios.put(
      `/full_documents/${fullDocumentId}/input_mask_update_journal`,
      { journal_id: journalId }
    )
  }
